export const messagesWhats = [
  {
    id: "true_5516992538331@c.us_3EB062604144145AE5EEDD",
    from: "5516992538331@c.us",
    body: "Olá! Seja bem-vindo. Meu nome é Gustavo Alves, e estou aqui para lhe apresentar um sistema revolucionário para a gestão de loteamentos: o Lotemobile. Percebi que você demonstrou interesse em nosso sistema e quero te contar mais sobre como ele pode facilitar e otimizar a gestão do seu empreendimento. Está pronto para conhecer as funcionalidades que podem transformar a sua gestão?",
    timestamp: 1737381863,
    type: "chat",
    isForwarded: false,
    hasMedia: false,
  },
  {
    id: "true_5516999669765@c.us_3EB062604144145AE5EEDF",
    from: "5516999669765@c.us",
    body: "Olá Gustavo! Sim, estou interessado. Pode me contar mais sobre as funcionalidades?",
    timestamp: 1737381963,
    type: "chat",
    isForwarded: false,
    hasMedia: false,
  },
  {
    id: "true_5516992538331@c.us_3EB062604144145AE5EEDG",
    from: "5516992538331@c.us",
    body: "Claro! O Lotemobile oferece uma gestão completa de loteamentos, com controle de vendas, financeiro, contratos e muito mais. Tudo isso em uma plataforma intuitiva e fácil de usar.",
    timestamp: 1737382063,
    type: "chat",
    isForwarded: false,
    hasMedia: false,
  },
  {
    id: "true_5516999669765@c.us_3EB062604144145AE5EEDH",
    from: "5516999669765@c.us",
    body: "Isso parece ótimo! E como funciona o controle financeiro?",
    timestamp: 1737382163,
    type: "chat",
    isForwarded: false,
    hasMedia: false,
  },
  {
    id: "true_5516992538331@c.us_3EB062604144145AE5EEDI",
    from: "5516992538331@c.us",
    body: "No controle financeiro, você pode gerenciar todas as receitas e despesas do seu loteamento, emitir boletos, acompanhar pagamentos e gerar relatórios detalhados.",
    timestamp: 1737382263,
    type: "chat",
    isForwarded: false,
    hasMedia: false,
  },
  {
    id: "true_5516999669765@c.us_3EB062604144145AE5EEDJ",
    from: "5516999669765@c.us",
    body: "Perfeito! Como faço para começar a usar o Lotemobile?",
    timestamp: 1737382363,
    type: "chat",
    isForwarded: false,
    hasMedia: false,
  },
  {
    id: "true_5516992538331@c.us_3EB062604144145AE5EEDK",
    from: "5516992538331@c.us",
    body: "Você pode acessar nosso site e se cadastrar para uma demonstração gratuita. Se precisar de ajuda, estou à disposição!",
    timestamp: 1737382463,
    type: "chat",
    isForwarded: false,
    hasMedia: false,
  },
];

export const canpaigns = [
  {
    id: "120214892004180682",

    name: "[FP] [Cadastro Site] [Publico Quente]",

    objective: "OUTCOME_LEADS",

    status: "PAUSED",

    effective_status: "PAUSED",

    insights: {
      spend: "141.4",

      impressions: "3215",

      clicks: "33",

      actions: [
        {
          action_type: "onsite_web_app_view_content",

          value: "6",
        },

        {
          action_type: "landing_page_view",

          value: "5",
        },

        {
          action_type: "onsite_web_view_content",

          value: "6",
        },

        {
          action_type: "post_engagement",

          value: "303",
        },

        {
          action_type: "page_engagement",

          value: "303",
        },

        {
          action_type: "lead",

          value: "3",
        },

        {
          action_type: "view_content",

          value: "6",
        },

        {
          action_type: "onsite_web_lead",

          value: "3",
        },

        {
          action_type: "post",

          value: "1",
        },

        {
          action_type: "offsite_conversion.fb_pixel_lead",

          value: "3",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "3",
        },

        {
          action_type: "video_view",

          value: "277",
        },

        {
          action_type: "omni_view_content",

          value: "6",
        },

        {
          action_type: "offsite_conversion.fb_pixel_view_content",

          value: "6",
        },

        {
          action_type: "post_reaction",

          value: "4",
        },

        {
          action_type: "link_click",

          value: "21",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "omni_view_content",

          value: "23.566667",
        },

        {
          action_type: "video_view",

          value: "0.510469",
        },

        {
          action_type: "link_click",

          value: "6.733333",
        },

        {
          action_type: "onsite_web_lead",

          value: "47.133333",
        },

        {
          action_type: "lead",

          value: "47.133333",
        },

        {
          action_type: "page_engagement",

          value: "0.466667",
        },

        {
          action_type: "view_content",

          value: "23.566667",
        },

        {
          action_type: "post_engagement",

          value: "0.466667",
        },

        {
          action_type: "landing_page_view",

          value: "28.28",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "23.566667",
        },

        {
          action_type: "onsite_web_view_content",

          value: "23.566667",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "47.133333",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120214895342420682",

        name: "Ad3 - Estático",

        effective_status: "PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/469334025_120214747667370682_6951817597766509945_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeGf0D76BPgtnhDn4v2iiw-KwWZqu0qeFWnBZmq7Sp4VaSOxxlpEhYawMhJbwfmthEBkGE0H5TpCnpf1mkfs1jWi&_nc_ohc=thHREBJoDY0Q7kNvgF2LFOD&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&oh=00_AYBJTF3Lyu88egBZlGSBTSrdcN7RjkHaIV2f26Hnb-5WSA&oe=67987FDF",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214916795310682",

        name: "Ad4 - Estático 2",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/470009691_120214916921590682_1837378952074476924_n.png?_nc_cat=102&ccb=1-7&_nc_eui2=AeFOLsrjmXxVUe3P9VXaLXxXuXOYdVdSLYy5c5h1V1ItjMBZ7gv_tBeeHPi5e8FjE9YmM0wsLDGut67KNY7Mp6nR&_nc_ohc=ItxtZSV00z8Q7kNvgEl_Inr&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAnQKIV4xmKAdZxW8zXLIQNN0epIphJolIoW98N7Nvlvg&oe=679861D7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214978879290682",

        name: "Ad4 - Estático 2",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/470009691_120214916921590682_1837378952074476924_n.png?_nc_cat=102&ccb=1-7&_nc_eui2=AeFOLsrjmXxVUe3P9VXaLXxXuXOYdVdSLYy5c5h1V1ItjMBZ7gv_tBeeHPi5e8FjE9YmM0wsLDGut67KNY7Mp6nR&_nc_ohc=ItxtZSV00z8Q7kNvgEl_Inr&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAnQKIV4xmKAdZxW8zXLIQNN0epIphJolIoW98N7Nvlvg&oe=679861D7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214978879280682",

        name: "Ad2 - Bate papo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOa_MIowqaKrHwOcXawq2qyUkqY4bXENQmTPUV5gPXoIcUNRTIYZPb3r_UiAdZP404YIcr8tt0Yqu5EUYFvvXeT.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU5Njc2MjkzNjA1ODcyMywidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeHAhDl1QvT33VwSl0C8PVJ6ZCZMsIaSkD9kJkywhpKQP26lhv5ALmAbOwdNe-RMJ4A5tJ_leQzl5yUcno6CfGl5&strext=1&vs=622a816d5dac6d1d&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HS0FPLUJ0dVFMRzJmQTRFQUJwMEtOcl9tLUV6Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dIN1MtUnZ2TUpjV3lCRUVBRGZPZTkzTG0wNVVickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsaNja2WsI8CFQIoAkMzLBdAUuIcrAgxJxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYA4kOzNDHf54MrFMftDHA2ig9fQG08t2Ao9I296fDMJGw&oe=679487DA&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469855282_1272345580680670_2748645235957542532_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeG-SPDVEFTGn0ZfYGjIkUzd1oXJ9Y_rLaHWhcn1j-stoWbo-iP5gcM7PllVQXtn_-HWppSoVhBnA4-WgYpXbgcK&_nc_ohc=yIBw6L6_a2wQ7kNvgEaBB89&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCZ9ZnBzRg9ammirGK1lXF9a7bJJ8E2G5kD_MCERLbu7w&oe=67987082",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214978879250682",

        name: "Ad1 - Vídeo Rodrigo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNgQQKJ2Nivqw8Lea2sTFa14xNl3GmM1tRqQzXnNLRJpDdYrsSxgBNF3cQdMdNyZSZHfpGcgO3c3Z51zuX-J6sy.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjE2NzMxODYwNjAyNjI4NDksInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=100&_nc_eui2=AeEf5tf9KB_eAu6rGHl5qzuTdv0Yq2heRYB2_RiraF5FgJKNNvIc4bxY-RHiJlAsYx_HU5QNhrwy6S7iVQiaOMP0&strext=1&vs=a587cfbe3652c1e2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSk1pQXh6TE54VEZWaGdFQUM5STRJbDdub2NIYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dNWmZBUnpqc09fSlRsc0pBR2hic1ZqWWhVZ2ZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJoL3nsyf8PgFFQIoAkMzLBdASq7ZFocrAhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCw9TdzAJXR9H6HrvMEzgw40HakY7LyWODJdgy7SKF5Bg&oe=6794722B&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470015398_609687371492954_7591477999581754356_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeGPlPjlUshZfUgI14btNZVfQq8ddBvFm1NCrx10G8WbU7hHQbJYSvaTsoR9r6KMd-daZJ2tYYkrgLuByJvWKSxR&_nc_ohc=w1dXXMw5SvcQ7kNvgHeSF8Y&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYD_T4zR7VwPVsIo_aGfDN7-W0Q4fxKyhVEzX76L9bxobA&oe=67987209",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214978879260682",

        name: "Ad3 - Estático",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/469334025_120214747667370682_6951817597766509945_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeGf0D76BPgtnhDn4v2iiw-KwWZqu0qeFWnBZmq7Sp4VaSOxxlpEhYawMhJbwfmthEBkGE0H5TpCnpf1mkfs1jWi&_nc_ohc=thHREBJoDY0Q7kNvgF2LFOD&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&oh=00_AYBJTF3Lyu88egBZlGSBTSrdcN7RjkHaIV2f26Hnb-5WSA&oe=67987FDF",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214917256650682",

        name: "Ad4 - Estático 2",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/470009691_120214916921590682_1837378952074476924_n.png?_nc_cat=102&ccb=1-7&_nc_eui2=AeFOLsrjmXxVUe3P9VXaLXxXuXOYdVdSLYy5c5h1V1ItjMBZ7gv_tBeeHPi5e8FjE9YmM0wsLDGut67KNY7Mp6nR&_nc_ohc=ItxtZSV00z8Q7kNvgEl_Inr&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAnQKIV4xmKAdZxW8zXLIQNN0epIphJolIoW98N7Nvlvg&oe=679861D7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214895342410682",

        name: "Ad3 - Estático",

        effective_status: "ADSET_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/469334025_120214747667370682_6951817597766509945_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeGf0D76BPgtnhDn4v2iiw-KwWZqu0qeFWnBZmq7Sp4VaSOxxlpEhYawMhJbwfmthEBkGE0H5TpCnpf1mkfs1jWi&_nc_ohc=thHREBJoDY0Q7kNvgF2LFOD&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&oh=00_AYBJTF3Lyu88egBZlGSBTSrdcN7RjkHaIV2f26Hnb-5WSA&oe=67987FDF",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214893711790682",

        name: "Ad2 - Bate papo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOa_MIowqaKrHwOcXawq2qyUkqY4bXENQmTPUV5gPXoIcUNRTIYZPb3r_UiAdZP404YIcr8tt0Yqu5EUYFvvXeT.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU5Njc2MjkzNjA1ODcyMywidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeHAhDl1QvT33VwSl0C8PVJ6ZCZMsIaSkD9kJkywhpKQP26lhv5ALmAbOwdNe-RMJ4A5tJ_leQzl5yUcno6CfGl5&strext=1&vs=622a816d5dac6d1d&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HS0FPLUJ0dVFMRzJmQTRFQUJwMEtOcl9tLUV6Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dIN1MtUnZ2TUpjV3lCRUVBRGZPZTkzTG0wNVVickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsaNja2WsI8CFQIoAkMzLBdAUuIcrAgxJxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYA4kOzNDHf54MrFMftDHA2ig9fQG08t2Ao9I296fDMJGw&oe=679487DA&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469855282_1272345580680670_2748645235957542532_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeG-SPDVEFTGn0ZfYGjIkUzd1oXJ9Y_rLaHWhcn1j-stoWbo-iP5gcM7PllVQXtn_-HWppSoVhBnA4-WgYpXbgcK&_nc_ohc=yIBw6L6_a2wQ7kNvgEaBB89&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCZ9ZnBzRg9ammirGK1lXF9a7bJJ8E2G5kD_MCERLbu7w&oe=67987082",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214894243900682",

        name: "Ad2 - Bate papo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOa_MIowqaKrHwOcXawq2qyUkqY4bXENQmTPUV5gPXoIcUNRTIYZPb3r_UiAdZP404YIcr8tt0Yqu5EUYFvvXeT.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU5Njc2MjkzNjA1ODcyMywidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeHAhDl1QvT33VwSl0C8PVJ6ZCZMsIaSkD9kJkywhpKQP26lhv5ALmAbOwdNe-RMJ4A5tJ_leQzl5yUcno6CfGl5&strext=1&vs=622a816d5dac6d1d&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HS0FPLUJ0dVFMRzJmQTRFQUJwMEtOcl9tLUV6Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dIN1MtUnZ2TUpjV3lCRUVBRGZPZTkzTG0wNVVickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsaNja2WsI8CFQIoAkMzLBdAUuIcrAgxJxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYA4kOzNDHf54MrFMftDHA2ig9fQG08t2Ao9I296fDMJGw&oe=679487DA&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469855282_1272345580680670_2748645235957542532_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeG-SPDVEFTGn0ZfYGjIkUzd1oXJ9Y_rLaHWhcn1j-stoWbo-iP5gcM7PllVQXtn_-HWppSoVhBnA4-WgYpXbgcK&_nc_ohc=yIBw6L6_a2wQ7kNvgEaBB89&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCZ9ZnBzRg9ammirGK1lXF9a7bJJ8E2G5kD_MCERLbu7w&oe=67987082",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214892003710682",

        name: "Ad1 - Vídeo Rodrigo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNgQQKJ2Nivqw8Lea2sTFa14xNl3GmM1tRqQzXnNLRJpDdYrsSxgBNF3cQdMdNyZSZHfpGcgO3c3Z51zuX-J6sy.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjE2NzMxODYwNjAyNjI4NDksInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=100&_nc_eui2=AeEf5tf9KB_eAu6rGHl5qzuTdv0Yq2heRYB2_RiraF5FgJKNNvIc4bxY-RHiJlAsYx_HU5QNhrwy6S7iVQiaOMP0&strext=1&vs=a587cfbe3652c1e2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSk1pQXh6TE54VEZWaGdFQUM5STRJbDdub2NIYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dNWmZBUnpqc09fSlRsc0pBR2hic1ZqWWhVZ2ZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJoL3nsyf8PgFFQIoAkMzLBdASq7ZFocrAhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCw9TdzAJXR9H6HrvMEzgw40HakY7LyWODJdgy7SKF5Bg&oe=6794722B&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470015398_609687371492954_7591477999581754356_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeGPlPjlUshZfUgI14btNZVfQq8ddBvFm1NCrx10G8WbU7hHQbJYSvaTsoR9r6KMd-daZJ2tYYkrgLuByJvWKSxR&_nc_ohc=w1dXXMw5SvcQ7kNvgHeSF8Y&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYD_T4zR7VwPVsIo_aGfDN7-W0Q4fxKyhVEzX76L9bxobA&oe=67987209",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214892305050682",

        name: "Ad1 - Vídeo Rodrigo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNgQQKJ2Nivqw8Lea2sTFa14xNl3GmM1tRqQzXnNLRJpDdYrsSxgBNF3cQdMdNyZSZHfpGcgO3c3Z51zuX-J6sy.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjE2NzMxODYwNjAyNjI4NDksInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=100&_nc_eui2=AeEf5tf9KB_eAu6rGHl5qzuTdv0Yq2heRYB2_RiraF5FgJKNNvIc4bxY-RHiJlAsYx_HU5QNhrwy6S7iVQiaOMP0&strext=1&vs=a587cfbe3652c1e2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSk1pQXh6TE54VEZWaGdFQUM5STRJbDdub2NIYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dNWmZBUnpqc09fSlRsc0pBR2hic1ZqWWhVZ2ZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJoL3nsyf8PgFFQIoAkMzLBdASq7ZFocrAhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCw9TdzAJXR9H6HrvMEzgw40HakY7LyWODJdgy7SKF5Bg&oe=6794722B&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470015398_609687371492954_7591477999581754356_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeGPlPjlUshZfUgI14btNZVfQq8ddBvFm1NCrx10G8WbU7hHQbJYSvaTsoR9r6KMd-daZJ2tYYkrgLuByJvWKSxR&_nc_ohc=w1dXXMw5SvcQ7kNvgHeSF8Y&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AsYbBRbXFR85rZmuA5YtZZa&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYD_T4zR7VwPVsIo_aGfDN7-W0Q4fxKyhVEzX76L9bxobA&oe=67987209",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120214719927650682",

    name: "[FP] [Cadastro Instantâneo] [Público Quente]",

    objective: "OUTCOME_LEADS",

    status: "ACTIVE",

    effective_status: "ACTIVE",

    insights: {
      spend: "643.61",

      impressions: "33247",

      clicks: "573",

      actions: [
        {
          action_type: "onsite_web_app_view_content",

          value: "39",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "2",
        },

        {
          action_type: "landing_page_view",

          value: "40",
        },

        {
          action_type: "onsite_web_view_content",

          value: "39",
        },

        {
          action_type: "post_engagement",

          value: "2829",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "10",
        },

        {
          action_type: "comment",

          value: "1",
        },

        {
          action_type: "page_engagement",

          value: "2830",
        },

        {
          action_type: "lead",

          value: "77",
        },

        {
          action_type: "view_content",

          value: "39",
        },

        {
          action_type: "onsite_web_lead",

          value: "5",
        },

        {
          action_type: "post",

          value: "17",
        },

        {
          action_type: "like",

          value: "1",
        },

        {
          action_type: "offsite_conversion.fb_pixel_lead",

          value: "5",
        },

        {
          action_type: "search",

          value: "3",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "4",
        },

        {
          action_type: "onsite_conversion.lead_grouped",

          value: "72",
        },

        {
          action_type: "offsite_conversion.fb_pixel_search",

          value: "3",
        },

        {
          action_type: "video_view",

          value: "2432",
        },

        {
          action_type: "omni_view_content",

          value: "39",
        },

        {
          action_type: "offsite_conversion.fb_pixel_view_content",

          value: "39",
        },

        {
          action_type: "post_reaction",

          value: "100",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "2",
        },

        {
          action_type: "link_click",

          value: "269",
        },

        {
          action_type: "omni_search",

          value: "3",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "omni_search",

          value: "214.536667",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "321.805",
        },

        {
          action_type: "omni_view_content",

          value: "16.502821",
        },

        {
          action_type: "video_view",

          value: "0.264642",
        },

        {
          action_type: "link_click",

          value: "2.392602",
        },

        {
          action_type: "like",

          value: "643.61",
        },

        {
          action_type: "onsite_web_lead",

          value: "128.722",
        },

        {
          action_type: "lead",

          value: "8.358571",
        },

        {
          action_type: "page_engagement",

          value: "0.227424",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "64.361",
        },

        {
          action_type: "search",

          value: "214.536667",
        },

        {
          action_type: "view_content",

          value: "16.502821",
        },

        {
          action_type: "post_engagement",

          value: "0.227504",
        },

        {
          action_type: "landing_page_view",

          value: "16.09025",
        },

        {
          action_type: "onsite_conversion.lead_grouped",

          value: "8.939028",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "321.805",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "16.502821",
        },

        {
          action_type: "onsite_web_view_content",

          value: "16.502821",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "160.9025",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120214719927740682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYAb6xD6yckoZWZEE4qXwXN3JYV-LjKwi98TiVaoPNAY4g&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214719927670682",

        name: "AD | Mapa de Vendas",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYB-hAEOwmztoUHg9s4rgnnnqsUUN8mT-BmQiwry7hcykg&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214719927720682",

        name: "AD | Mapa Google",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYCDFimW1keyX7tFQ3kfRjEfY3r65FqqFWfU8ZxMbrV0tQ&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120215104882000682",

        name: "AD / Depoimento",

        effective_status: "ACTIVE",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOC_D1HBG60SDvFjGjbd179-6WcIA85W-RLGtbQhP9Ebg3yzJdbGI6uzP-C1UeOlgLHDn_VPZ2RUIYyowL-nHzi.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjYxMTkyODc4NDUwNzMyMiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeHLfLwhTGci50O6lbMEc3vFTnipXc3pY-dOeKldzelj50QCbFc5ySJgBPdv4Xf45i1n0R4ZXKDxfPC83voB3wJ0&strext=1&vs=2c4cd4c2002a5f2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSHFrREJ3MGpzZXJBbVVEQU5WME5ZOEttUWwtYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dLUklEQngycmVWSlI2b0JBTHdmeEgyQmVOWktickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJvTGoN34opYCFQIoAkMzLBdANeZmZmZmZhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCFiUnIkEkwQIlk5oqwxXdSjGqpbrcMLdAUgWQJ1jJJJA&oe=679477A9&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470815867_584995711149878_1966519180982975618_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeGIVsALtrRnDdNIEgGgsrlk1Qu4xT2bqTzVC7jFPZupPDKaEJxLQhbiNVVKlmdJ_LtLz3RkoXHgP07OY2bMSXXN&_nc_ohc=p0mBenKIfm0Q7kNvgFuBWcY&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYA7RZ_feRHwpjMgtZMxUlxMK-bzZdDAHiHmwJpew3zoDQ&oe=679892A9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "197.58",
      },

      {
        id: "120214719927730682",

        name: "AD / Reels Black November",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNBtLPBTyRjZz8arlZkw46b6NLVr9u07IQ8J-tNZleGMIEMiiWOfBZBhRlw6JNRTD2Mn8N8Md3QEN8XNTWnQpK6.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjk4OTMxMzg0NjU0NjQ1MiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeGpQabkNtmuSRFhmEgnJyoTgU0KkJAJ-_eBTQqQkAn79wBz5996rZQvFtdS5i1Lm_N3ffQEey305D6Gt7X7TU1V&strext=1&vs=a9f4a5bfb1ec4d6e&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HUGVmNGh2WVJMNS0tQTRDQU1zTFZXQVR0TGR4Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBVnc0QnRIUDY0bGFJME5BTzR0YzlyRkM1Z05ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqjAqMbS8cEDFQIoAkMzLBdAPndLxqfvnhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC3cvNt4BUhdfLehHsp7KKPmldiiTw1OOpsaHPacccbHA&oe=679479D1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467517693_3789482444601471_842377333092311274_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeHqzW4ACawCUo0V6eK1wC_Z7er-YPTJhkvt6v5g9MmGS89y0V9iwLl0WRiK7WUE8uyK-J_PUbGx7pZm4nLno8Lc&_nc_ohc=--LwDvFP-dYQ7kNvgFaThSJ&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCWEJK4Xc_KVJYMHMYwRCWqF_PN-vJN2sE4m2jgCa3Dzw&oe=67987DF0",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214747734030682",

        name: "AD / Vendas",

        effective_status: "ACTIVE",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/469334025_120214747667370682_6951817597766509945_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeGf0D76BPgtnhDn4v2iiw-KwWZqu0qeFWnBZmq7Sp4VaSOxxlpEhYawMhJbwfmthEBkGE0H5TpCnpf1mkfs1jWi&_nc_ohc=thHREBJoDY0Q7kNvgF2LFOD&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&oh=00_AYAxdPXGnvpk3MRNTpKYI5R2Mf9AHWO3g2sTZ6z0nbfBBw&oe=67987FDF",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "2.94",
      },

      {
        id: "120214719927700682",

        name: "AD / Reels Black November",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOwqD6tgMK_0wKIWfFpoh1-nbPFq66zNp1z5E0wnlkZwN_Th_790mPKreWtVxXKNNizKybWlIyRoWq_MstLa-qt.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU1NTQwNzI1Mzc5NzkxNiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=103&_nc_eui2=AeEKEvDFD_fyb3gOogDt5ARberB_w0JkKTt6sH_DQmQpO1HCmmozMRj5mDK9ON0aIR_IyfWjiPMgYnkgUJQ2y628&strext=1&vs=94f1ed0cd2fe993c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HS0pENnh0OGNDR0RHOFlCQU9fNnNsWWlDc1lBYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dLcEU2QnNHWUZJWUhoSUdBT1d4dm9KZW1zNV9ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJrjwi8H6yPwBFQIoAkMzLBdAQUzMzMzMzRgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDchU-PzWRXmAwwoLnGOoI2Ebt-e41jCLIRkhiUlFMP9g&oe=67948BA2&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467428736_558851930200445_8473056545262988083_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeGxZTGV1hgtQxZHS-LRBJ2JKnqhb3PR-cYqeqFvc9H5xm9vfpx-9SklywXp5dBkeT5o-HutI76bzkpPiC7H5E7a&_nc_ohc=s7WhL8_YYWcQ7kNvgEp8ah7&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYDRZBsvMQdVnDxZg2GJ4kYC3bHbPjkEihuyAhMldPE-IQ&oe=67987A80",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214719927710682",

        name: "AD / Reels mundo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYA1dBnE3lRwWexZcjNaTq-UmFQ_FazyRMqdgj7ctF34Rg&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214719927660682",

        name: "AD / Estático",

        effective_status: "ACTIVE",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&oh=00_AYAbOpZZa-AOj08GuloG9HMYnSwL2CYW7xiCb7o4t0gHMA&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "82.23",
      },

      {
        id: "120214719927380682",

        name: "AD | Black Friday",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214783363530682",

        name: "AD / Reels Mapa Interativo",

        effective_status: "ACTIVE",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQON1JWQGWaBXUUha6vd-QLQB-aVnMW50LMMd28k8V4PCQIbYDBsy4EodJrlNjRd9uqSl9y5OKx3Gj4QIDteSJU9.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEyNzY2MTg0MjY5OTE5NzAsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeEHBbjFoHzCt7lIMwa0VBz1EfoIdx4xOO4R-gh3HjE47qY4Y2Oth5i2x5IImACN-lDEOLlroJlTwbkhyiQiRazI&strext=1&vs=6c8c619c209364a0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRlhYQmh4MDduSUd1VDRHQUlHTHRvOVcxN01jYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMlUtaHZHZi1vLU5yZ0dBSHZRWmJPam1ORnZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsSV1r38xMQEFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC2yQo3tP8mViWYfYnOz7G8brKdxDXlCDYEgv8L7Ta98g&oe=679471E5&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470325071_1972909299858333_5262403533913648451_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeExe1_801uyFnR87DjWvzwJboSTK4Udx-xuhJMrhR3H7K8A0HkxyWKjbjtNdoiqpfEkggRtnns1AzGK0apC13ag&_nc_ohc=Ist8OTy1anIQ7kNvgFDCtTs&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAT8RFeL660u7M6BgkBqIY5lYTo4GjkfrVzEMumgaoNBg&oe=67989219",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "18.34",
      },

      {
        id: "120215750118140682",

        name: "AD | 1 Mês Grátis",

        effective_status: "ACTIVE",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/473215942_120215750893240682_4943052469322315819_n.jpg?_nc_cat=104&ccb=1-7&_nc_eui2=AeEC2udsJ6s3joCcCMmPIqMo4OgsL4i235Pg6CwviLbfk7kTEKXB2KoiitHIPwki9TQmD6Rl5UgJeaEpWFUn20TS&_nc_ohc=oDPXaNExidQQ7kNvgFtdV60&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYDSt4VBQMuavsI-wL2yOosAgsRFgeum5WJeVTiD5ue1oQ&oe=67987F8A",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "86.41",
      },

      {
        id: "120215105250000682",

        name: "AD / Depoimento",

        effective_status: "ACTIVE",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOC_D1HBG60SDvFjGjbd179-6WcIA85W-RLGtbQhP9Ebg3yzJdbGI6uzP-C1UeOlgLHDn_VPZ2RUIYyowL-nHzi.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjYxMTkyODc4NDUwNzMyMiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeHLfLwhTGci50O6lbMEc3vFTnipXc3pY-dOeKldzelj50QCbFc5ySJgBPdv4Xf45i1n0R4ZXKDxfPC83voB3wJ0&strext=1&vs=2c4cd4c2002a5f2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSHFrREJ3MGpzZXJBbVVEQU5WME5ZOEttUWwtYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dLUklEQngycmVWSlI2b0JBTHdmeEgyQmVOWktickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJvTGoN34opYCFQIoAkMzLBdANeZmZmZmZhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCFiUnIkEkwQIlk5oqwxXdSjGqpbrcMLdAUgWQJ1jJJJA&oe=679477A9&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470815867_584995711149878_1966519180982975618_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeGIVsALtrRnDdNIEgGgsrlk1Qu4xT2bqTzVC7jFPZupPDKaEJxLQhbiNVVKlmdJ_LtLz3RkoXHgP07OY2bMSXXN&_nc_ohc=p0mBenKIfm0Q7kNvgFuBWcY&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYA7RZ_feRHwpjMgtZMxUlxMK-bzZdDAHiHmwJpew3zoDQ&oe=679892A9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "1.08",
      },

      {
        id: "120214747734040682",

        name: "AD / Vendas",

        effective_status: "ACTIVE",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/469334025_120214747667370682_6951817597766509945_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeGf0D76BPgtnhDn4v2iiw-KwWZqu0qeFWnBZmq7Sp4VaSOxxlpEhYawMhJbwfmthEBkGE0H5TpCnpf1mkfs1jWi&_nc_ohc=thHREBJoDY0Q7kNvgF2LFOD&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&oh=00_AYAxdPXGnvpk3MRNTpKYI5R2Mf9AHWO3g2sTZ6z0nbfBBw&oe=67987FDF",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.18",
      },

      {
        id: "120214719927490682",

        name: "AD / Estático",

        effective_status: "ACTIVE",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&oh=00_AYAbOpZZa-AOj08GuloG9HMYnSwL2CYW7xiCb7o4t0gHMA&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "313.41",
      },

      {
        id: "120214783363580682",

        name: "AD / Reels Mapa Interativo",

        effective_status: "ACTIVE",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQON1JWQGWaBXUUha6vd-QLQB-aVnMW50LMMd28k8V4PCQIbYDBsy4EodJrlNjRd9uqSl9y5OKx3Gj4QIDteSJU9.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEyNzY2MTg0MjY5OTE5NzAsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeEHBbjFoHzCt7lIMwa0VBz1EfoIdx4xOO4R-gh3HjE47qY4Y2Oth5i2x5IImACN-lDEOLlroJlTwbkhyiQiRazI&strext=1&vs=6c8c619c209364a0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRlhYQmh4MDduSUd1VDRHQUlHTHRvOVcxN01jYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMlUtaHZHZi1vLU5yZ0dBSHZRWmJPam1ORnZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsSV1r38xMQEFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC2yQo3tP8mViWYfYnOz7G8brKdxDXlCDYEgv8L7Ta98g&oe=679471E5&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470325071_1972909299858333_5262403533913648451_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeExe1_801uyFnR87DjWvzwJboSTK4Udx-xuhJMrhR3H7K8A0HkxyWKjbjtNdoiqpfEkggRtnns1AzGK0apC13ag&_nc_ohc=Ist8OTy1anIQ7kNvgFDCtTs&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAT8RFeL660u7M6BgkBqIY5lYTo4GjkfrVzEMumgaoNBg&oe=67989219",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "2.63",
      },

      {
        id: "120214719927410682",

        name: "AD / Reels mundo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYA1dBnE3lRwWexZcjNaTq-UmFQ_FazyRMqdgj7ctF34Rg&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214746903540682",

        name: "AD / Vendas",

        effective_status: "ADSET_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/469334025_120214747667370682_6951817597766509945_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeGf0D76BPgtnhDn4v2iiw-KwWZqu0qeFWnBZmq7Sp4VaSOxxlpEhYawMhJbwfmthEBkGE0H5TpCnpf1mkfs1jWi&_nc_ohc=thHREBJoDY0Q7kNvgF2LFOD&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&oh=00_AYAxdPXGnvpk3MRNTpKYI5R2Mf9AHWO3g2sTZ6z0nbfBBw&oe=67987FDF",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214719927550682",

        name: "AD / Reels mundo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYA1dBnE3lRwWexZcjNaTq-UmFQ_FazyRMqdgj7ctF34Rg&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214719927610682",

        name: "AD / Estático",

        effective_status: "ADSET_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&oh=00_AYAbOpZZa-AOj08GuloG9HMYnSwL2CYW7xiCb7o4t0gHMA&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214719927470682",

        name: "AD / Reels mundo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYA1dBnE3lRwWexZcjNaTq-UmFQ_FazyRMqdgj7ctF34Rg&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214719927500682",

        name: "AD / Estático",

        effective_status: "ADSET_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&oh=00_AYAbOpZZa-AOj08GuloG9HMYnSwL2CYW7xiCb7o4t0gHMA&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214747734020682",

        name: "AD / Vendas",

        effective_status: "ADSET_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/469334025_120214747667370682_6951817597766509945_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeGf0D76BPgtnhDn4v2iiw-KwWZqu0qeFWnBZmq7Sp4VaSOxxlpEhYawMhJbwfmthEBkGE0H5TpCnpf1mkfs1jWi&_nc_ohc=thHREBJoDY0Q7kNvgF2LFOD&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&oh=00_AYAxdPXGnvpk3MRNTpKYI5R2Mf9AHWO3g2sTZ6z0nbfBBw&oe=67987FDF",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214783263410682",

        name: "AD / Reels Mapa Interativo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQO7ZTAVCYojt4QLa6DlYZJDCvXFiyVEGefzXoJ8VMAQUW48TZezGfdaLm-Zbkuz0A6Za7HKeo6NnNhqMp9tVCd8.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjIyMDc3OTkyOTk3NDQ5ODcsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5oaHZtdHJ1bmsuNzIwLmRhc2hfaDI2NC1iYXNpYy1nZW4yXzcyMHAifQ&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=111&_nc_eui2=AeEA-vF66vAJHui3caUTBm9HrUh_6LG4iW6tSH_osbiJbvVfyKC2PKcVWicf9JGl7s-MyoePYWOmcWdw_3wks-Oz&strext=1&vs=4e65a8ea837dc1e5&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSldTX3h0TllEVGY2eDhDQUNlZzdrTGhwa0ZFYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dLajFfaHZPUmpCczVKVUpBQWJoMkoyS0JCUWxickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJraT-c_q_usHFQIoCWhodm10cnVuaywXQDwqfvnbItEYGWRhc2hfaDI2NC1iYXNpYy1nZW4yXzcyMHARAHUCAA&ccb=9-4&oh=00_AYCZjYqE-yAa1xOhzM9aLPnZpWVNAL7sxCP-d33SLgK55g&oe=679470EE&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469479325_910996024478517_5065737248995382626_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeGmAaFK_NwjtbDZb2iFOwJYU-Lcc1sPZ3dT4txzWw9nd48Xk-n8stUWgixZCluAqGmz9o1oariaTwHSOoSHMVO9&_nc_ohc=NfDcOriv_6AQ7kNvgG0dVxj&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBVFSxXzfDIbgm9PFiRy5XtQIj9QdK66sXuD635kM__8w&oe=67986430",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214783363520682",

        name: "AD / Reels Mapa Interativo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQO7ZTAVCYojt4QLa6DlYZJDCvXFiyVEGefzXoJ8VMAQUW48TZezGfdaLm-Zbkuz0A6Za7HKeo6NnNhqMp9tVCd8.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjIyMDc3OTkyOTk3NDQ5ODcsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=111&_nc_eui2=AeEA-vF66vAJHui3caUTBm9HrUh_6LG4iW6tSH_osbiJbvVfyKC2PKcVWicf9JGl7s-MyoePYWOmcWdw_3wks-Oz&strext=1&vs=4e65a8ea837dc1e5&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSldTX3h0TllEVGY2eDhDQUNlZzdrTGhwa0ZFYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dLajFfaHZPUmpCczVKVUpBQWJoMkoyS0JCUWxickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJraT-c_q_usHFQIoAkMzLBdAPCp--dsi0RgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDxFrt5fNAkZGvKBF0gfL9CYOX04LdPAA47zWdqFaqobg&oe=679470EE&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469479325_910996024478517_5065737248995382626_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeGmAaFK_NwjtbDZb2iFOwJYU-Lcc1sPZ3dT4txzWw9nd48Xk-n8stUWgixZCluAqGmz9o1oariaTwHSOoSHMVO9&_nc_ohc=NfDcOriv_6AQ7kNvgG0dVxj&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AUGNgC9qD9uvx7lDl6YzvNL&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBVFSxXzfDIbgm9PFiRy5XtQIj9QdK66sXuD635kM__8w&oe=67986430",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120214583583850682",

    name: "[FP] [Branding EVENTO LOTE] [prédio do evento] [posc.manual]",

    objective: "OUTCOME_AWARENESS",

    status: "PAUSED",

    effective_status: "PAUSED",

    insights: {
      spend: "29.68",

      impressions: "8020",

      clicks: "19",

      actions: [
        {
          action_type: "post_engagement",

          value: "394",
        },

        {
          action_type: "page_engagement",

          value: "394",
        },

        {
          action_type: "video_view",

          value: "379",
        },

        {
          action_type: "post_reaction",

          value: "2",
        },

        {
          action_type: "link_click",

          value: "13",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "video_view",

          value: "0.078311",
        },

        {
          action_type: "link_click",

          value: "2.283077",
        },

        {
          action_type: "page_engagement",

          value: "0.07533",
        },

        {
          action_type: "post_engagement",

          value: "0.07533",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120214583583930682",

        name: "Ad1 - Reels Wesley",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOWP_WYHH-ceWDWdTDfGsbVHc7JDhJe6mhzIcL9Ym6xT4iHqv_NplYWX6tS0FGmnBUQgYFbXKQaoqTD6nduY1gA.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwOTg4MzM5MzE4OTIzMzEsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=111&_nc_eui2=AeHx9iooYFH3NrCPHZgKlftCRDbwMROGkGhENvAxE4aQaGbozrHWW6ytLsCSYXF8aBGd_Z0TZa87xnozOzjM-5m8&strext=1&vs=c5563d9505b081d0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTlRBOEJ2ZmtjWEMxNWdGQU42NzhDYktMdU5fYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dFUHQ4UnZFdEJXcEdoc0NBSkV1UmF2QW5wNU9ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtbZ6-LG2PMDFQIoAkMzLBdAOjztkWhysBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYBe3YjdLBfGm0Dcq615h-HBpA5p8MwZGkgNDD2d8UnkiA&oe=67948F2E&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/468803622_1102789407978263_4328896728637853429_n.jpg?_nc_cat=109&ccb=1-7&_nc_eui2=AeHXR7gIBLj-yzg0KqNmy3ze0DDrW-a-QA3QMOtb5r5ADWJJtKIbjq0URmmwXHVZeo3QnltMPHDg21lzRGVpplok&_nc_ohc=hZpdwAXEdCgQ7kNvgHNOgdM&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Adnb1Yej3X7-1ZEdZLJo_a_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=282d23&_nc_sid=58080a&oh=00_AYBKeY52KZOYN6Uwk8D6nNbdkUmXyBrntP1Tp_hRSQH4EQ&oe=679865F1",
        },

        texts: {
          message:
            "A Lote Mobile está marcando presença na Lote Experience Connection SP! 🚀\n\nVenha conhecer nosso stand e descubra como nossa tecnologia pode revolucionar a gestão do seu loteamento. 🗺️💻\n\nCom soluções como mapa interativo, CRM integrado, automação de processos e muito mais. Surpreenda-se com o que podemos fazer pelo seu negócio!\n\nPasse no nosso stand e vamos conversar!👋",

          headline: "Lote Mobile",

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120214400231130682",

    name: "[FP] [VídeoView] [Branding]",

    objective: "OUTCOME_ENGAGEMENT",

    status: "ACTIVE",

    effective_status: "ACTIVE",

    insights: {
      spend: "427.56",

      impressions: "124215",

      clicks: "126",

      actions: [
        {
          action_type: "onsite_web_app_view_content",

          value: "2",
        },

        {
          action_type: "landing_page_view",

          value: "10",
        },

        {
          action_type: "onsite_web_view_content",

          value: "2",
        },

        {
          action_type: "post_engagement",

          value: "65107",
        },

        {
          action_type: "page_engagement",

          value: "65107",
        },

        {
          action_type: "view_content",

          value: "2",
        },

        {
          action_type: "video_view",

          value: "65000",
        },

        {
          action_type: "omni_view_content",

          value: "2",
        },

        {
          action_type: "offsite_conversion.fb_pixel_view_content",

          value: "2",
        },

        {
          action_type: "post_reaction",

          value: "3",
        },

        {
          action_type: "link_click",

          value: "104",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "omni_view_content",

          value: "213.78",
        },

        {
          action_type: "video_view",

          value: "0.006578",
        },

        {
          action_type: "link_click",

          value: "4.111154",
        },

        {
          action_type: "page_engagement",

          value: "0.006567",
        },

        {
          action_type: "view_content",

          value: "213.78",
        },

        {
          action_type: "post_engagement",

          value: "0.006567",
        },

        {
          action_type: "landing_page_view",

          value: "42.756",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "213.78",
        },

        {
          action_type: "onsite_web_view_content",

          value: "213.78",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120214977537440682",

        name: "Ad1 - Reels Gustavo e Wesley",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQM4fvK_zVJfYefQz6cnLnP85aDY522LwD4FwTgpX3m3KMynwnI5LfCTDuly2WoWsjeeGZN6zXKWFtxA4NSJNNeb.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjUxNDU0MDUxMTczNzE2OSwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeFuuR8vDswsxrpxJSk3bJy1yOjPCN3G82rI6M8I3cbzarpMrbxc2fifS4JOjmdWwHM7OlBBru-bek5Zlc5CBy9N&strext=1&vs=9a4f5cb12a3dd787&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQ1RELUJzR0UzblExMFFOQVBnbF8yeVVjUWxmYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dDeUotUnV2WVBRVFJSOEdBRGJnTFVueXFaNDNickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqLV5caZ_ukBFQIoAkMzLBdAUuIcrAgxJxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCLtzS68qLcz1RpPwn4Y6_IUcqS8f7P5_4ClE95s-Wpzw&oe=67947FEE&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469165388_1804589640345176_3791345535182750404_n.jpg?_nc_cat=103&ccb=1-7&_nc_eui2=AeFX_v-avlpWgtfBz8SvoSblRv0_HXmGkG1G_T8deYaQbet2vaXyPI7TQW-NQpEIC2fXIF0fpGC2VTcJCoY8cJKR&_nc_ohc=R6u4GVXZYWgQ7kNvgFPhlDj&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBla1k4BUjbZJ4D_i_-7R1DrPKuXfGylGqv3VG-cUsdIg&oe=679879C1",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214977537470682",

        name: "Ad2 - Reels mundo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBDll5HUy8seyi8CTNBRHBwtKO7b--l1BF9btVKUu78JQ&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214977537450682",

        name: "Ad3 - Reels Mapa Interativo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQON1JWQGWaBXUUha6vd-QLQB-aVnMW50LMMd28k8V4PCQIbYDBsy4EodJrlNjRd9uqSl9y5OKx3Gj4QIDteSJU9.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEyNzY2MTg0MjY5OTE5NzAsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeEHBbjFoHzCt7lIMwa0VBz1EfoIdx4xOO4R-gh3HjE47qY4Y2Oth5i2x5IImACN-lDEOLlroJlTwbkhyiQiRazI&strext=1&vs=6c8c619c209364a0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRlhYQmh4MDduSUd1VDRHQUlHTHRvOVcxN01jYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMlUtaHZHZi1vLU5yZ0dBSHZRWmJPam1ORnZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsSV1r38xMQEFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC2yQo3tP8mViWYfYnOz7G8brKdxDXlCDYEgv8L7Ta98g&oe=679471E5&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470325071_1972909299858333_5262403533913648451_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeExe1_801uyFnR87DjWvzwJboSTK4Udx-xuhJMrhR3H7K8A0HkxyWKjbjtNdoiqpfEkggRtnns1AzGK0apC13ag&_nc_ohc=Ist8OTy1anIQ7kNvgFDCtTs&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBIACgoTr7DuY9HA39l5zEpARTeG-GbvfVyFcSGQY83Ug&oe=67989219",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214895180430682",

        name: "Ad3 - Reels Mapa Interativo",

        effective_status: "ACTIVE",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQON1JWQGWaBXUUha6vd-QLQB-aVnMW50LMMd28k8V4PCQIbYDBsy4EodJrlNjRd9uqSl9y5OKx3Gj4QIDteSJU9.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEyNzY2MTg0MjY5OTE5NzAsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeEHBbjFoHzCt7lIMwa0VBz1EfoIdx4xOO4R-gh3HjE47qY4Y2Oth5i2x5IImACN-lDEOLlroJlTwbkhyiQiRazI&strext=1&vs=6c8c619c209364a0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRlhYQmh4MDduSUd1VDRHQUlHTHRvOVcxN01jYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMlUtaHZHZi1vLU5yZ0dBSHZRWmJPam1ORnZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsSV1r38xMQEFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC2yQo3tP8mViWYfYnOz7G8brKdxDXlCDYEgv8L7Ta98g&oe=679471E5&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470325071_1972909299858333_5262403533913648451_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeExe1_801uyFnR87DjWvzwJboSTK4Udx-xuhJMrhR3H7K8A0HkxyWKjbjtNdoiqpfEkggRtnns1AzGK0apC13ag&_nc_ohc=Ist8OTy1anIQ7kNvgFDCtTs&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBIACgoTr7DuY9HA39l5zEpARTeG-GbvfVyFcSGQY83Ug&oe=67989219",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.92",
      },

      {
        id: "120214894835980682",

        name: "Ad2 - Reels mundo",

        effective_status: "ACTIVE",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBDll5HUy8seyi8CTNBRHBwtKO7b--l1BF9btVKUu78JQ&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "298.73",
      },

      {
        id: "120214894836020682",

        name: "Ad1 - Reels Gustavo e Wesley",

        effective_status: "ACTIVE",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQM4fvK_zVJfYefQz6cnLnP85aDY522LwD4FwTgpX3m3KMynwnI5LfCTDuly2WoWsjeeGZN6zXKWFtxA4NSJNNeb.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjUxNDU0MDUxMTczNzE2OSwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeFuuR8vDswsxrpxJSk3bJy1yOjPCN3G82rI6M8I3cbzarpMrbxc2fifS4JOjmdWwHM7OlBBru-bek5Zlc5CBy9N&strext=1&vs=9a4f5cb12a3dd787&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQ1RELUJzR0UzblExMFFOQVBnbF8yeVVjUWxmYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dDeUotUnV2WVBRVFJSOEdBRGJnTFVueXFaNDNickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqLV5caZ_ukBFQIoAkMzLBdAUuIcrAgxJxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCLtzS68qLcz1RpPwn4Y6_IUcqS8f7P5_4ClE95s-Wpzw&oe=67947FEE&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469165388_1804589640345176_3791345535182750404_n.jpg?_nc_cat=103&ccb=1-7&_nc_eui2=AeFX_v-avlpWgtfBz8SvoSblRv0_HXmGkG1G_T8deYaQbet2vaXyPI7TQW-NQpEIC2fXIF0fpGC2VTcJCoY8cJKR&_nc_ohc=R6u4GVXZYWgQ7kNvgFPhlDj&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBla1k4BUjbZJ4D_i_-7R1DrPKuXfGylGqv3VG-cUsdIg&oe=679879C1",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.03",
      },

      {
        id: "120214773163170682",

        name: "AD / Reels Gustavo e Wesley",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQM4fvK_zVJfYefQz6cnLnP85aDY522LwD4FwTgpX3m3KMynwnI5LfCTDuly2WoWsjeeGZN6zXKWFtxA4NSJNNeb.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjUxNDU0MDUxMTczNzE2OSwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeFuuR8vDswsxrpxJSk3bJy1yOjPCN3G82rI6M8I3cbzarpMrbxc2fifS4JOjmdWwHM7OlBBru-bek5Zlc5CBy9N&strext=1&vs=9a4f5cb12a3dd787&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQ1RELUJzR0UzblExMFFOQVBnbF8yeVVjUWxmYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dDeUotUnV2WVBRVFJSOEdBRGJnTFVueXFaNDNickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqLV5caZ_ukBFQIoAkMzLBdAUuIcrAgxJxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCLtzS68qLcz1RpPwn4Y6_IUcqS8f7P5_4ClE95s-Wpzw&oe=67947FEE&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469165388_1804589640345176_3791345535182750404_n.jpg?_nc_cat=103&ccb=1-7&_nc_eui2=AeFX_v-avlpWgtfBz8SvoSblRv0_HXmGkG1G_T8deYaQbet2vaXyPI7TQW-NQpEIC2fXIF0fpGC2VTcJCoY8cJKR&_nc_ohc=R6u4GVXZYWgQ7kNvgFPhlDj&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBla1k4BUjbZJ4D_i_-7R1DrPKuXfGylGqv3VG-cUsdIg&oe=679879C1",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214773110270682",

        name: "AD / Reels Gustavo e Wesley",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQM4fvK_zVJfYefQz6cnLnP85aDY522LwD4FwTgpX3m3KMynwnI5LfCTDuly2WoWsjeeGZN6zXKWFtxA4NSJNNeb.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjUxNDU0MDUxMTczNzE2OSwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzZS43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeFuuR8vDswsxrpxJSk3bJy1yOjPCN3G82rI6M8I3cbzarpMrbxc2fifS4JOjmdWwHM7OlBBru-bek5Zlc5CBy9N&strext=1&vs=9a4f5cb12a3dd787&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQ1RELUJzR0UzblExMFFOQVBnbF8yeVVjUWxmYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dDeUotUnV2WVBRVFJSOEdBRGJnTFVueXFaNDNickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqLV5caZ_ukBFQIoA0MzZSwXQFLiHKwIMScYGWRhc2hfaDI2NC1iYXNpYy1nZW4yXzcyMHARAHUCAA&ccb=9-4&oh=00_AYA9t4jo-Qz15MYNzDumkpoY_G_qfNu7e6RjVQQONslRGA&oe=67947FEE&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469165388_1804589640345176_3791345535182750404_n.jpg?_nc_cat=103&ccb=1-7&_nc_eui2=AeFX_v-avlpWgtfBz8SvoSblRv0_HXmGkG1G_T8deYaQbet2vaXyPI7TQW-NQpEIC2fXIF0fpGC2VTcJCoY8cJKR&_nc_ohc=R6u4GVXZYWgQ7kNvgFPhlDj&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBla1k4BUjbZJ4D_i_-7R1DrPKuXfGylGqv3VG-cUsdIg&oe=679879C1",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214657596650682",

        name: "AD / Reels mundo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBDll5HUy8seyi8CTNBRHBwtKO7b--l1BF9btVKUu78JQ&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214657252820682",

        name: "AD / Reels mundo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBDll5HUy8seyi8CTNBRHBwtKO7b--l1BF9btVKUu78JQ&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214455792060682",

        name: "AD / Reels Black November 2",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOwqD6tgMK_0wKIWfFpoh1-nbPFq66zNp1z5E0wnlkZwN_Th_790mPKreWtVxXKNNizKybWlIyRoWq_MstLa-qt.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU1NTQwNzI1Mzc5NzkxNiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=103&_nc_eui2=AeEKEvDFD_fyb3gOogDt5ARberB_w0JkKTt6sH_DQmQpO1HCmmozMRj5mDK9ON0aIR_IyfWjiPMgYnkgUJQ2y628&strext=1&vs=94f1ed0cd2fe993c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HS0pENnh0OGNDR0RHOFlCQU9fNnNsWWlDc1lBYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dLcEU2QnNHWUZJWUhoSUdBT1d4dm9KZW1zNV9ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJrjwi8H6yPwBFQIoAkMzLBdAQUzMzMzMzRgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDchU-PzWRXmAwwoLnGOoI2Ebt-e41jCLIRkhiUlFMP9g&oe=67948BA2&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467428736_558851930200445_8473056545262988083_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeGxZTGV1hgtQxZHS-LRBJ2JKnqhb3PR-cYqeqFvc9H5xm9vfpx-9SklywXp5dBkeT5o-HutI76bzkpPiC7H5E7a&_nc_ohc=s7WhL8_YYWcQ7kNvgEp8ah7&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYACR0GumnNDLLB2g3BI-LiVCxxr2IytTjviZP4iO--U5w&oe=67987A80",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231240682",

        name: "AD / Reels Black November",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNBtLPBTyRjZz8arlZkw46b6NLVr9u07IQ8J-tNZleGMIEMiiWOfBZBhRlw6JNRTD2Mn8N8Md3QEN8XNTWnQpK6.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjk4OTMxMzg0NjU0NjQ1MiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeGpQabkNtmuSRFhmEgnJyoTgU0KkJAJ-_eBTQqQkAn79wBz5996rZQvFtdS5i1Lm_N3ffQEey305D6Gt7X7TU1V&strext=1&vs=a9f4a5bfb1ec4d6e&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HUGVmNGh2WVJMNS0tQTRDQU1zTFZXQVR0TGR4Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBVnc0QnRIUDY0bGFJME5BTzR0YzlyRkM1Z05ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqjAqMbS8cEDFQIoAkMzLBdAPndLxqfvnhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC3cvNt4BUhdfLehHsp7KKPmldiiTw1OOpsaHPacccbHA&oe=679479D1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467517693_3789482444601471_842377333092311274_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeHqzW4ACawCUo0V6eK1wC_Z7er-YPTJhkvt6v5g9MmGS89y0V9iwLl0WRiK7WUE8uyK-J_PUbGx7pZm4nLno8Lc&_nc_ohc=--LwDvFP-dYQ7kNvgFaThSJ&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAs2GW7jthXlDn-IVDe8sbu_LkS0GVh6o86BAy7GUjWTw&oe=67987DF0",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231170682",

        name: "AD / Reels Black November",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNBtLPBTyRjZz8arlZkw46b6NLVr9u07IQ8J-tNZleGMIEMiiWOfBZBhRlw6JNRTD2Mn8N8Md3QEN8XNTWnQpK6.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjk4OTMxMzg0NjU0NjQ1MiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeGpQabkNtmuSRFhmEgnJyoTgU0KkJAJ-_eBTQqQkAn79wBz5996rZQvFtdS5i1Lm_N3ffQEey305D6Gt7X7TU1V&strext=1&vs=a9f4a5bfb1ec4d6e&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HUGVmNGh2WVJMNS0tQTRDQU1zTFZXQVR0TGR4Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBVnc0QnRIUDY0bGFJME5BTzR0YzlyRkM1Z05ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqjAqMbS8cEDFQIoAkMzLBdAPndLxqfvnhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC3cvNt4BUhdfLehHsp7KKPmldiiTw1OOpsaHPacccbHA&oe=679479D1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467517693_3789482444601471_842377333092311274_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeHqzW4ACawCUo0V6eK1wC_Z7er-YPTJhkvt6v5g9MmGS89y0V9iwLl0WRiK7WUE8uyK-J_PUbGx7pZm4nLno8Lc&_nc_ohc=--LwDvFP-dYQ7kNvgFaThSJ&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAs2GW7jthXlDn-IVDe8sbu_LkS0GVh6o86BAy7GUjWTw&oe=67987DF0",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214455319850682",

        name: "AD / Reels Black November 2",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOwqD6tgMK_0wKIWfFpoh1-nbPFq66zNp1z5E0wnlkZwN_Th_790mPKreWtVxXKNNizKybWlIyRoWq_MstLa-qt.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU1NTQwNzI1Mzc5NzkxNiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzZS43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=103&_nc_eui2=AeEKEvDFD_fyb3gOogDt5ARberB_w0JkKTt6sH_DQmQpO1HCmmozMRj5mDK9ON0aIR_IyfWjiPMgYnkgUJQ2y628&strext=1&vs=94f1ed0cd2fe993c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HS0pENnh0OGNDR0RHOFlCQU9fNnNsWWlDc1lBYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dLcEU2QnNHWUZJWUhoSUdBT1d4dm9KZW1zNV9ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJrjwi8H6yPwBFQIoA0MzZSwXQEFMzMzMzM0YGWRhc2hfaDI2NC1iYXNpYy1nZW4yXzcyMHARAHUCAA&ccb=9-4&oh=00_AYCj6tcEOXNJPBM8DcReYKk9xiIWaA2uuioB6XpCzTlNzA&oe=67948BA2&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467428736_558851930200445_8473056545262988083_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeGxZTGV1hgtQxZHS-LRBJ2JKnqhb3PR-cYqeqFvc9H5xm9vfpx-9SklywXp5dBkeT5o-HutI76bzkpPiC7H5E7a&_nc_ohc=s7WhL8_YYWcQ7kNvgEp8ah7&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYACR0GumnNDLLB2g3BI-LiVCxxr2IytTjviZP4iO--U5w&oe=67987A80",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231220682",

        name: "AD | Reels Insta IA",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456060756_364899466664886_7048515971288709583_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHa-RJBMSSZlfh2aZWHsimeoMSGgQXsJvWgxIaBBewm9QmK7AEZ9CsRUIeTdnRBIb37DigTkMwDXS0yF35kvqje&_nc_ohc=JlVO-raO_ygQ7kNvgFGYbDG&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYAHoY-XR_SYNyfvicFdOI_n869_BSMZAwOkEBDsrMldqA&oe=67987EA4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231210682",

        name: "AD | Reels Insta Atendimento",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456201965_1396846377659450_7384666972614963224_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFPTQBKcfONLmq4Hdxb1CjiocmiHXZUHiGhyaIddlQeIStdSicHkB5jLPb7YkYJ-7zAfnWUwpA_Ld6DS5N334r0&_nc_ohc=g78UA8S5ilgQ7kNvgFcZg75&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYAITHx0SonlpUYUmn4OOLkNy2rPN8tz46JN83sHXIC7RQ&oe=67986E4D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231120682",

        name: "AD | Reels Insta IA",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456061399_2539187706289161_8373357006410509866_n.jpg?_nc_cat=100&ccb=1-7&_nc_eui2=AeH3BIePAxocB4ayxZADB4XyW0P5h7oazRFbQ_mHuhrNETOOw1pNw9ZldNBVBSt8keEOWyp3zYZvGHr6vbVwl1Xr&_nc_ohc=s-JMPWkSo2kQ7kNvgFDJM4r&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYCD2y3s9hsVZ7rvZA6KIFtUhga6arZhteNCNwHSaYLFJw&oe=67987DC4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231140682",

        name: "AD | Reels Insta Atendimento",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456203116_1959581781181322_8712192002101299045_n.jpg?_nc_cat=106&ccb=1-7&_nc_eui2=AeH3jCYz0UlEfHdCL5DTyriGQOP3TFGwsGBA4_dMUbCwYDMmm8TSnkSK73zXgpYpqv4y8HQcRWSwlBv5x1dv2MjG&_nc_ohc=kaiuDRBISI8Q7kNvgHOllep&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYDFBuPXCP7sgPUS-bGNAvu6-1fEO7oC8Q2-ABFsSznFLw&oe=67986C2C",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231150682",

        name: "AD | Reels Insta Case",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456322192_1028081952352462_4741750611119828495_n.jpg?_nc_cat=106&ccb=1-7&_nc_eui2=AeEBSOJsoRpAVIfCPkLrwdps6wMi0eTbw-frAyLR5NvD5-PCwm8WVcQSBpV2yrdmjrzuUpdt1hgPJNDAOghtcoZz&_nc_ohc=a9yQ2rCPABgQ7kNvgGEQKaT&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYAvLnB5dwNqZkItibyU5oqJGDsbnmuYtePaCksg--gHNg&oe=679882AC",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231270682",

        name: "AD | Reels Insta Case",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456039110_1818079005688538_938095938554705880_n.jpg?_nc_cat=108&ccb=1-7&_nc_eui2=AeEUiM-SrFy3fs-vkDpmB-QQjXCj6B_VCymNcKPoH9ULKWHAAwfT894UIbf5XhmDXTazHVv-6CzIhIWdoZfjxAHE&_nc_ohc=AUW2juLvvYYQ7kNvgEh0wLi&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYAUJMOnv2DZmK0OkcGgpTQdwQBoE26GgySVNth8iHTKHQ&oe=679867B4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231190682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBpZuURoZChZDitdPwJaeviGpm5NOPYJVE1zO7PK-ZkEQ&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231200682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBpZuURoZChZDitdPwJaeviGpm5NOPYJVE1zO7PK-ZkEQ&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231160682",

        name: "AD | Video Mapa v2",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQO9PpIQLwdcYc5xGSSisPNu89l3k5ZiT6fbFP7YfPwZ3XjxrXR3ZFUKd1dDKfG6Wcg7ta2OuTYiWl50VKd4CYbZ.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQyODcwNTgzMDA1MzQyMCwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2hpZ2hfMV92MSJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=108&_nc_eui2=AeFWe3k1EVTAKlLuWlVGtYV6Y3oshWsxGJFjeiyFazEYkRgFhqCYSHHdlxzGhz6vc6uh-wxagK8t4QhQidu2tyQG&strext=1&vs=87b94a07b567edd3&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQVRiU2hwcTJHamtoNGdDQUtkelQzLVB3UTBPYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dIM2RSaHJwOHByR1k0QUZBSGk5NnQ3amgySVhidjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtiYtav7-cIBFQIoAkMzLBdAOSIMSbpeNRgOZGFzaF9oaWdoXzFfdjERAHUCAA&ccb=9-4&oh=00_AYD7HF65656-4gdM3DE5dDW5nmvfJZicRVCjhc2SOTqzMw&oe=6794945B&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/438212874_966271238525289_3980684890386525851_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeEj4O_SBVJvlpEr-tCDhOdxi4R6m7eP-qmLhHqbt4_6qbsLybD4Vi36AHybm97NackOkZkj_Bviajtuf9SXBEVL&_nc_ohc=a_XSJWSix2wQ7kNvgECZyoX&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYDb0gZhVEJ0EnJXXeHsNCfNv4IlVMRQajpSfkXcrsd6tw&oe=67987A7F",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231260682",

        name: "AD | Video Mapa v1",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMfwAuSuDHkly3a-5MRmkXNhLtYSjqZyMsz5NruL_AJJlkKgj1DADgVazp5NMULdliDFITO1QBkWXw8tn0ssIFA.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQ0OTAzMjg3NzY2Mjg3NiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2hpZ2hfMV92MSJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=105&_nc_eui2=AeGe6X-yICyTtulXWN1GPU4_jE__cVMjvdqMT_9xUyO92kKJ6t3k0QAxMLS-k6zwHPkcrGsVpolunNtuLvHCYMt4&strext=1&vs=630dfc5fc9b77d0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTzZvVHhsOWJxWnZQS1lIQU9JZGZiQ1BVNVVUYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dNbW5SQm8zVXFjSF9MUUZBQUV5OWZuNDdHcy1idjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJriK09KTmcwBFQIoAkMzLBdAOYhysCDEnBgOZGFzaF9oaWdoXzFfdjERAHUCAA&ccb=9-4&oh=00_AYDqWx4QYv840dbycl9lsV9NTBz-0IFyh-OVXernkUD58g&oe=67948908&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/438220570_411298821760268_4056244743871648038_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeED1UmFdu12UL9jOuSAjKRje-5dm2DXTKx77l2bYNdMrIsMORS1bC7RVK3Z5SPE7txviaAb9RlzUQ5vUy2uTFFS&_nc_ohc=U4ttg2ff2tYQ7kNvgH58TXN&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCH0e1G0UrJQ-OfQM_YzG-uTY_PAx6zpg1MmH8g63J0gQ&oe=67988FA5",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214400231230682",

        name: "AD | Video IA",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOoo-4-UMOmympo9y1QvqI5vRPDKt8A_dL1UvudEy-Lm3F5fX63_eMISZ9uBLWLYgCc3v_oAAyDN7U4ItKQ6WEM.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQzNTM3MDM3NTczOTM3NCwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2hpZ2hfMV92MSJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=108&_nc_eui2=AeFvsQuQa9OXzDnlQx34Qjohz0jOtCg1rNXPSM60KDWs1esbLnm02yfKzwEQ0TR-mgCubKgNxBOCH-xCnfQ4niK8&strext=1&vs=1dc4e403dfc8844c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQXZlUXhvVjRFYXlsWGNCQUNTMDgwRUNXR3hhYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dQWkRSeHAzUTR5S0lrSUdBTktqSzl3MldRUlNidjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtzfu4ny_cUBFQIoAkMzLBdAL5mZmZmZmhgOZGFzaF9oaWdoXzFfdjERAHUCAA&ccb=9-4&oh=00_AYCKylzOLV2FaJHqBvzrFQ89wl0TWE6HvWjzGwLjA2dtxw&oe=67948BE7&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/426962232_26358581030399395_923893081814852703_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeFcckKgDNisIkzK320-xVa0qetLf9ssUS-p60t_2yxRL62oqr3E1nv-x_YzF73k-xZw9czUVlZui6mFFaSAtV_i&_nc_ohc=Pdl3RR9zBH8Q7kNvgHrdOfF&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=ArDSitHxZFiYFOmzVypJit_&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCNseAJlRS8hmxlGC_aSYZ63ZPVh2hzLcPt2FbrZedEPg&oe=67988457",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120214368990830682",

    name: "[FP] [Cadastro Site] [Publico Frio]",

    objective: "OUTCOME_LEADS",

    status: "PAUSED",

    effective_status: "PAUSED",

    insights: {
      spend: "848.42",

      impressions: "25138",

      clicks: "477",

      actions: [
        {
          action_type: "onsite_web_app_view_content",

          value: "170",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "6",
        },

        {
          action_type: "landing_page_view",

          value: "162",
        },

        {
          action_type: "onsite_web_view_content",

          value: "170",
        },

        {
          action_type: "complete_registration",

          value: "5",
        },

        {
          action_type: "post_engagement",

          value: "3672",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "14",
        },

        {
          action_type: "comment",

          value: "1",
        },

        {
          action_type: "page_engagement",

          value: "3673",
        },

        {
          action_type: "photo_view",

          value: "1",
        },

        {
          action_type: "lead",

          value: "59",
        },

        {
          action_type: "view_content",

          value: "170",
        },

        {
          action_type: "onsite_web_lead",

          value: "59",
        },

        {
          action_type: "post",

          value: "54",
        },

        {
          action_type: "omni_complete_registration",

          value: "5",
        },

        {
          action_type: "like",

          value: "1",
        },

        {
          action_type: "offsite_conversion.fb_pixel_lead",

          value: "59",
        },

        {
          action_type: "search",

          value: "3",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "9",
        },

        {
          action_type: "offsite_conversion.fb_pixel_search",

          value: "3",
        },

        {
          action_type: "video_view",

          value: "3176",
        },

        {
          action_type: "omni_view_content",

          value: "170",
        },

        {
          action_type: "offsite_conversion.fb_pixel_view_content",

          value: "170",
        },

        {
          action_type: "post_reaction",

          value: "138",
        },

        {
          action_type: "offsite_conversion.fb_pixel_complete_registration",

          value: "5",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "4",
        },

        {
          action_type: "link_click",

          value: "288",
        },

        {
          action_type: "omni_search",

          value: "3",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "omni_search",

          value: "282.806667",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "212.105",
        },

        {
          action_type: "omni_view_content",

          value: "4.990706",
        },

        {
          action_type: "video_view",

          value: "0.267135",
        },

        {
          action_type: "link_click",

          value: "2.945903",
        },

        {
          action_type: "like",

          value: "848.42",
        },

        {
          action_type: "complete_registration",

          value: "169.684",
        },

        {
          action_type: "omni_complete_registration",

          value: "169.684",
        },

        {
          action_type: "onsite_web_lead",

          value: "14.38",
        },

        {
          action_type: "lead",

          value: "14.38",
        },

        {
          action_type: "page_engagement",

          value: "0.230988",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "60.601429",
        },

        {
          action_type: "search",

          value: "282.806667",
        },

        {
          action_type: "view_content",

          value: "4.990706",
        },

        {
          action_type: "post_engagement",

          value: "0.231051",
        },

        {
          action_type: "landing_page_view",

          value: "5.23716",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "141.403333",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "4.990706",
        },

        {
          action_type: "onsite_web_view_content",

          value: "4.990706",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "94.268889",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120214892321750682",

        name: "Ad7 - Simulador",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNsOVsatTfdhaPFjF6PZ_ZhWZ41nbAXchj39FEdK2hw-Zd7SSm_ejVSjxnHmOu50ZE44KpX2fPIuILaHe-Lo3fD.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU0MjE2MjY1MTk4OTIzNSwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=104&_nc_eui2=AeHKQfszAPIAyczNQ-v8-zDNnFYdCAgE8IWcVh0ICATwhQkhPyzcqo-RSAt7-KPH-rbCQQ4tEwgMslu33imNVYGv&strext=1&vs=5f105d64d102fcb2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSXJUQVJ3WGtJU3hkbjBHQUNjVFItNEV4NnBEYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dJZVctUnVRZEJrOHVRUURBT3ctSzJ4UDZMbzZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJuaTwsSCxvYBFQIoAkMzLBdAIWZmZmZmZhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYAz8aHZDW0KJUGg_-4-iZ8nGtj7R_vhS2-U9j5o0SaFVA&oe=679493C7&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469836951_2026316341139254_7491305635629217068_n.jpg?_nc_cat=104&ccb=1-7&_nc_eui2=AeGSvrS6oFKEOHR5GNnwHRvdoCDCa3AMDyWgIMJrcAwPJUylzAZgDXfcWtEKk8AOY2p1S8fi4gSRDyVUAMBuA6Fz&_nc_ohc=WRm7jB471PoQ7kNvgG3Wsag&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAoSMeX8IEsgo4KxAx2Ril-Kk7Uw09jF4xAEpDxotCTZQ&oe=679897C4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "245.42",
      },

      {
        id: "120214892321740682",

        name: "Ad8 - WhatsApp",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNBoeFgyKg1O0u44sJdynJSyXxky0ewUWAJXdLORP5bF_KpD9mdJ7gDAfZOmMTg_8R3mgNe2pO0exeAkR9c8tau.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQ1NDI5MDEwNzQ0MTkyNywidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeH40MdmgD2r8gpEOEP-If_OrTVf9sNVTaetNV_2w1VNp5Q2MpY33Km1vJNNQroXvAI9-WP6VB2T5th9kM_TYAhx&strext=1&vs=ec4df51e88c6480c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQjRfQUJ4UTYtTEdrRUVmQU9YNHBUVmpYMUl2Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dCRHktaHRaajZJOU1Hc0VBTm5xSlJnbkxRaGNickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJo6M1YeVy84BFQIoAkMzLBdAH3bItDlYEBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYBpov_5bK6sS6Hx4f2qe9igExgims9YPnpmLWp2rE1mIQ&oe=67949DCD&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469740584_1131488035149903_9134675616801449943_n.jpg?_nc_cat=100&ccb=1-7&_nc_eui2=AeGyaByDNrQGHi-h6Ti3jb1zGt2YDQrQN9Qa3ZgNCtA31Nc-PbPmfeuqq3jEGRWHf1gBeiaFby1kJ86tcOyKGY_o&_nc_ohc=WGISg4diaBAQ7kNvgH0-d6Q&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCgzqiXxND_hj2PG2It1q2bmOh_Tm3gzMXP-CjopH7i1w&oe=67988C41",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "1.5",
      },

      {
        id: "120214892321810682",

        name: "Ad5 - Mapa Gustavo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOEY19sbwCAu8U6AauMiBSQWJrFJMEKgRmhIPX6ZvaX59Tz3uEFBD9wSJEBoZcHsXs5Z7fiSQ4j-N2PD_MSqjXW.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEyNTQ2ODI1NjI0MTAxMzksInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=103&_nc_eui2=AeFEegQXG9jcoSD8wmQN8L7XRiiO5Z0sBUdGKI7lnSwFRxJIV_Rduf2b4IckQjjzU6qT9FBf5IFSa5FUflSd9hNK&strext=1&vs=3b95997403519253&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSlRjQWh4Y1dON0w0Nk1CQUh5Z1ppOVJnbGx1Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dGYV8tUnZadjB0R3l2MFFBQnYweEhyRG1pWnlickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJrbagceRyLoEFQIoAkMzLBdAIqp--dsi0RgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC04d9x0h1JvBjTtSTCdA7uZca0Y7_APl3Rg-yA9nTW7g&oe=67947CBA&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469734512_931536798482761_7055854463663379245_n.jpg?_nc_cat=104&ccb=1-7&_nc_eui2=AeGhvV_3mRdF284R0QgxkOM4qGxLQvumKTqobEtC-6YpOu-M4We8gQzsUuv_LZVp9uCi-AsJejglyExRFCdSPGnU&_nc_ohc=md8o7sTFkcQQ7kNvgEJCFBu&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYB0Rf3wdT9B4w-0Sb1dlZpCRCTOCC47DRhh116QhfWGkw&oe=67987FA8",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "3.57",
      },

      {
        id: "120214892321780682",

        name: "Ad3 - App Gustavo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQM5y7rrpmfxCFTRZGOH8LHq7kpP0KOJO0W22NzcDFvD6ji7--7adZ2BlsGo8z9eQ1yEHEO19GQagmY2alEaUz5R.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjE3NDY2NzI2Mjk0MDE0MDAsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=103&_nc_eui2=AeEdOpFAEsWl8zDAXWa74PZjloFqYBFHVQGWgWpgEUdVAcpZc6V9ybL-lCvjXvP1rUN0YskgchZg18w_Sco1E6eQ&strext=1&vs=5724d2ea3015138f&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HUENuQVJ4WDg3QkJtTW9CQUc1OGt1SlpVd2Q1Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dCeWVBQnlLQmRkMjBPUUZBUEplZ2dLVko0WVdickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJvCc6pndpZoGFQIoAkMzLBdAJczMzMzMzRgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYD-vRVZdkux70YPakOAW5aHZmGYJpbQyfsUWzXsJpE3NQ&oe=6794716E&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469599757_440686935746335_882279243824494957_n.jpg?_nc_cat=102&ccb=1-7&_nc_eui2=AeGCVfYvi7lKCHaBdpw_Vrr3qC9rZ2zHuOuoL2tnbMe46zyi8eManrBGNjhh_jDXwg-3wig-u0SmS-H3bCFjI8rx&_nc_ohc=n_DK7xnvLUsQ7kNvgEFpTUd&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBfzHuGz1GcnasAAzhhDJc3ZLNZ3v1iNTscHuTNmAlN3w&oe=67986A78",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "1.56",
      },

      {
        id: "120214892321790682",

        name: "Ad1 - Reels mapa interativo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMNkIfRzfDZ4GWw7UmiiWuvUNG8SIIq5K6GB0VXhLTYEmASd8rkFU6Bg3lU28zK-HILdxAbCF1C_5b5O_1svgTr.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwOTQyMDA4MTkxNTU5MzcsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=111&_nc_eui2=AeGOCKgYLnWi-MtRKlb4cTCP7AuzpR5jl47sC7OlHmOXjtlaxnbr_v9pzxWlk0zaJq_oiRx85ScivY9BHSYGX0_C&strext=1&vs=1aba8d3face40a95&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQldfQWh6ZGlHOGF5aGtOQU1HOFdHNDBEbzljYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMXpCQnhrdFllaV9Mc05BSm54aUVYVmxqQTFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsKPnLLvyvEDFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYBxR0IBPKpHZ8Qn0_PX-TEtI8EuTeZzwj4ROQ-sStrX3Q&oe=67949F4A&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470017033_1091266409105727_1849412484213479495_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeFVbm5G5DVJWxTC_jkgGNPrlpm2OI_cwf-WmbY4j9zB__DUAVrBrYY248Bo9MAKPwOSxiYOEyf4At_b_Eo7BmPy&_nc_ohc=DWtWlM_KCgYQ7kNvgHdaslg&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYD0afn44wDYgvkXsfvs9hRugRJozFmAzMBWJF7XWr2zgA&oe=679869B5",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "38.37",
      },

      {
        id: "120215773449660682",

        name: "Ad7 - Simulador",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNsOVsatTfdhaPFjF6PZ_ZhWZ41nbAXchj39FEdK2hw-Zd7SSm_ejVSjxnHmOu50ZE44KpX2fPIuILaHe-Lo3fD.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU0MjE2MjY1MTk4OTIzNSwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=104&_nc_eui2=AeHKQfszAPIAyczNQ-v8-zDNnFYdCAgE8IWcVh0ICATwhQkhPyzcqo-RSAt7-KPH-rbCQQ4tEwgMslu33imNVYGv&strext=1&vs=5f105d64d102fcb2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSXJUQVJ3WGtJU3hkbjBHQUNjVFItNEV4NnBEYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dJZVctUnVRZEJrOHVRUURBT3ctSzJ4UDZMbzZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJuaTwsSCxvYBFQIoAkMzLBdAIWZmZmZmZhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYAz8aHZDW0KJUGg_-4-iZ8nGtj7R_vhS2-U9j5o0SaFVA&oe=679493C7&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469836951_2026316341139254_7491305635629217068_n.jpg?_nc_cat=104&ccb=1-7&_nc_eui2=AeGSvrS6oFKEOHR5GNnwHRvdoCDCa3AMDyWgIMJrcAwPJUylzAZgDXfcWtEKk8AOY2p1S8fi4gSRDyVUAMBuA6Fz&_nc_ohc=WRm7jB471PoQ7kNvgG3Wsag&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAoSMeX8IEsgo4KxAx2Ril-Kk7Uw09jF4xAEpDxotCTZQ&oe=679897C4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "38.34",
      },

      {
        id: "120215773449690682",

        name: "Ad6 - Recebimento",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQPLb8MD4WoubxxOMf06DXMvYXpXwSt66gShHVSqcL3VkgIwSXNrksmuRNqr29r7LbNIP1UXQs123mS76UFbHVKF.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjExNTI1MjE4Mjk4MjI4NzAsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeF8A4l8I1s8fmQipnaK9qIarSAmPtcNiSitICY-1w2JKDV8IldLoHGJfXdgi1crcb9j-qHYgmuAuLq8YXgW8ElF&strext=1&vs=761e6eaf3499c2ff&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRENzQVJ3eWFhMmx5bXdEQUJRaE1nNjVOS0VEYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dPSHEtaHRpdy1JZ0p3ZGpBS3RMU2R6R3lnOEtickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqzGmeTMjYwEFQIoAkMzLBdAIKp--dsi0RgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDo1-PM2F33ifbY8AMGBl8vIaW5poB4cje44fkp5yZLpw&oe=6794A1DA&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468722756_2558089844376993_1898227210247922960_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeH1HkI8o-UFOLpYdDJT95eC8PZTiFlve-3w9lOIWW977Rnsu3R9gKCBNCaUxHtawxYzanrpaVVHSmYAv2lGuN89&_nc_ohc=6s_VcLJtH4UQ7kNvgEFIDQr&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBM-TMPKLgBF9bxGcP-KNQNqw3ynmchsq82m1nPD1bWPw&oe=679876B3",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "1.07",
      },

      {
        id: "120215773449730682",

        name: "Ad2 - Site ideal",

        effective_status: "PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&oh=00_AYCGPzf5fd54HCYIF87M2-vpY5Ns8cliubyHfCz3vIHNig&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120215773449740682",

        name: "Ad1 - Reels Mapa Interativo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMNkIfRzfDZ4GWw7UmiiWuvUNG8SIIq5K6GB0VXhLTYEmASd8rkFU6Bg3lU28zK-HILdxAbCF1C_5b5O_1svgTr.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwOTQyMDA4MTkxNTU5MzcsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=111&_nc_eui2=AeGOCKgYLnWi-MtRKlb4cTCP7AuzpR5jl47sC7OlHmOXjtlaxnbr_v9pzxWlk0zaJq_oiRx85ScivY9BHSYGX0_C&strext=1&vs=1aba8d3face40a95&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQldfQWh6ZGlHOGF5aGtOQU1HOFdHNDBEbzljYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMXpCQnhrdFllaV9Mc05BSm54aUVYVmxqQTFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsKPnLLvyvEDFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYBxR0IBPKpHZ8Qn0_PX-TEtI8EuTeZzwj4ROQ-sStrX3Q&oe=67949F4A&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470017033_1091266409105727_1849412484213479495_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeFVbm5G5DVJWxTC_jkgGNPrlpm2OI_cwf-WmbY4j9zB__DUAVrBrYY248Bo9MAKPwOSxiYOEyf4At_b_Eo7BmPy&_nc_ohc=DWtWlM_KCgYQ7kNvgHdaslg&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYD0afn44wDYgvkXsfvs9hRugRJozFmAzMBWJF7XWr2zgA&oe=679869B5",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "21.31",
      },

      {
        id: "120215773449720682",

        name: "Ad3 - App Gustavo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOcbubeKB5UkZ9ol0BlL5H3FzSkClveFkF-1Gi4aRQL1QEot40Jt_M2RSz7Fb_s3abGUA7Y7lz6Aueyk_K9xfJP.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjg4NzE0MTc5Nzk2MjA0NzcsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeE_aTGe8_hFkWLUvpI1m3A4tSTKF9kHX321JMoX2QdffZCNmH2yltrWMT8gZPiRAXOcMkM_8AAdPKUsUf3x2Xt3&strext=1&vs=2ce37d0a6ff05f19&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HR0RrQkJ6V0IwaGtPdXdEQUF0WUJWZFhjZzFmYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEcUMteHRRMUFlN1FnZ0NBRU9kUGlUVllkVVNickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJvqxotW-oMIfFQIoAkMzLBdAJczMzMzMzRgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYBpPFbhaL4FxgzW8JXbl1UDgFZOaVRClVyoPLvqHzsPzA&oe=67947F0E&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469744073_383285458145819_1957413489952164467_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeFmMPYdOz8_dvT4LqxYyZNB00o1UF5t_lnTSjVQXm3-WViVgzqGc07OMLwkJug0wr58n-qLBGfGSQRhM_VfFTKk&_nc_ohc=w728iFim9vYQ7kNvgEFmKk9&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCw7WQ6QYS5hnkNuW5yzLoOlnReJ9U8_q37zQkLbpUOBw&oe=6798805A",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120215773449700682",

        name: "Ad5 - Mapa Gustavo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOEY19sbwCAu8U6AauMiBSQWJrFJMEKgRmhIPX6ZvaX59Tz3uEFBD9wSJEBoZcHsXs5Z7fiSQ4j-N2PD_MSqjXW.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEyNTQ2ODI1NjI0MTAxMzksInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=103&_nc_eui2=AeFEegQXG9jcoSD8wmQN8L7XRiiO5Z0sBUdGKI7lnSwFRxJIV_Rduf2b4IckQjjzU6qT9FBf5IFSa5FUflSd9hNK&strext=1&vs=3b95997403519253&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSlRjQWh4Y1dON0w0Nk1CQUh5Z1ppOVJnbGx1Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dGYV8tUnZadjB0R3l2MFFBQnYweEhyRG1pWnlickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJrbagceRyLoEFQIoAkMzLBdAIqp--dsi0RgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC04d9x0h1JvBjTtSTCdA7uZca0Y7_APl3Rg-yA9nTW7g&oe=67947CBA&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469734512_931536798482761_7055854463663379245_n.jpg?_nc_cat=104&ccb=1-7&_nc_eui2=AeGhvV_3mRdF284R0QgxkOM4qGxLQvumKTqobEtC-6YpOu-M4We8gQzsUuv_LZVp9uCi-AsJejglyExRFCdSPGnU&_nc_ohc=md8o7sTFkcQQ7kNvgEJCFBu&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYB0Rf3wdT9B4w-0Sb1dlZpCRCTOCC47DRhh116QhfWGkw&oe=67987FA8",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "4.46",
      },

      {
        id: "120215773449710682",

        name: "Ad4 - CRM Gustavo",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQN3CvUafTorU7Ma7iwLYYgMrxrDRpLjPRDe_aTAjyRpMIUamnXIYM51JC3DhRO1PoYfDfaf8C8JGTTTu0HifNC1.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjM4MzE3OTE2NTM3MzgyNzEsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=100&_nc_eui2=AeG6zTQXA_BMigvz7zyDE7LkgDMdUHaH1K2AMx1QdofUrVqsqfFaY_DTHpuWnlYrlsgRA7ICDwGzOUtncB_Oa1R9&strext=1&vs=4a2996ff35d5879a&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRHpfQVJ3MWNtLWhFb0FEQUVwdG5xM1p4dU1QYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBdlctUnVKQnBkUlZmRURBRXZZMlI3UXpPQkdickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJr7c_sXQv84NFQIoAkMzLBdAHAAAAAAAABgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCzPQAtyuhBcNPP8B2uG4UIltRstPKMsMv6EnG008CdoQ&oe=67947807&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469564027_572161368849962_4156503067035956185_n.jpg?_nc_cat=108&ccb=1-7&_nc_eui2=AeHldUGLAKVwFDcc_ezFbCw2T5QySEO5nKJPlDJIQ7mcolXpi4GUMyxDdwnmtUERSiss4Bj4cytAOHjGkGR8zZ-1&_nc_ohc=IpBYxDvJLv0Q7kNvgHAfMQe&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYANDawmgh5521TOHS1IQSo31EDJ-ubCUA_gluLj411b6w&oe=6798951A",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120215773449680682",

        name: "Ad8 - WhatsApp",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNBoeFgyKg1O0u44sJdynJSyXxky0ewUWAJXdLORP5bF_KpD9mdJ7gDAfZOmMTg_8R3mgNe2pO0exeAkR9c8tau.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQ1NDI5MDEwNzQ0MTkyNywidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeH40MdmgD2r8gpEOEP-If_OrTVf9sNVTaetNV_2w1VNp5Q2MpY33Km1vJNNQroXvAI9-WP6VB2T5th9kM_TYAhx&strext=1&vs=ec4df51e88c6480c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQjRfQUJ4UTYtTEdrRUVmQU9YNHBUVmpYMUl2Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dCRHktaHRaajZJOU1Hc0VBTm5xSlJnbkxRaGNickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJo6M1YeVy84BFQIoAkMzLBdAH3bItDlYEBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYBpov_5bK6sS6Hx4f2qe9igExgims9YPnpmLWp2rE1mIQ&oe=67949DCD&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469740584_1131488035149903_9134675616801449943_n.jpg?_nc_cat=100&ccb=1-7&_nc_eui2=AeGyaByDNrQGHi-h6Ti3jb1zGt2YDQrQN9Qa3ZgNCtA31Nc-PbPmfeuqq3jEGRWHf1gBeiaFby1kJ86tcOyKGY_o&_nc_ohc=WGISg4diaBAQ7kNvgH0-d6Q&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCgzqiXxND_hj2PG2It1q2bmOh_Tm3gzMXP-CjopH7i1w&oe=67988C41",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214892321770682",

        name: "Ad2 - Site ideal",

        effective_status: "PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&oh=00_AYCGPzf5fd54HCYIF87M2-vpY5Ns8cliubyHfCz3vIHNig&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "26.39",
      },

      {
        id: "120214892321760682",

        name: "Ad4 - CRM Gustavo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQN3CvUafTorU7Ma7iwLYYgMrxrDRpLjPRDe_aTAjyRpMIUamnXIYM51JC3DhRO1PoYfDfaf8C8JGTTTu0HifNC1.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjM4MzE3OTE2NTM3MzgyNzEsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=100&_nc_eui2=AeG6zTQXA_BMigvz7zyDE7LkgDMdUHaH1K2AMx1QdofUrVqsqfFaY_DTHpuWnlYrlsgRA7ICDwGzOUtncB_Oa1R9&strext=1&vs=4a2996ff35d5879a&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRHpfQVJ3MWNtLWhFb0FEQUVwdG5xM1p4dU1QYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBdlctUnVKQnBkUlZmRURBRXZZMlI3UXpPQkdickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJr7c_sXQv84NFQIoAkMzLBdAHAAAAAAAABgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCzPQAtyuhBcNPP8B2uG4UIltRstPKMsMv6EnG008CdoQ&oe=67947807&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469564027_572161368849962_4156503067035956185_n.jpg?_nc_cat=108&ccb=1-7&_nc_eui2=AeHldUGLAKVwFDcc_ezFbCw2T5QySEO5nKJPlDJIQ7mcolXpi4GUMyxDdwnmtUERSiss4Bj4cytAOHjGkGR8zZ-1&_nc_ohc=IpBYxDvJLv0Q7kNvgHAfMQe&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYANDawmgh5521TOHS1IQSo31EDJ-ubCUA_gluLj411b6w&oe=6798951A",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "5.41",
      },

      {
        id: "120214892321820682",

        name: "Ad6 - Recebimento",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQPLb8MD4WoubxxOMf06DXMvYXpXwSt66gShHVSqcL3VkgIwSXNrksmuRNqr29r7LbNIP1UXQs123mS76UFbHVKF.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjExNTI1MjE4Mjk4MjI4NzAsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=107&_nc_eui2=AeF8A4l8I1s8fmQipnaK9qIarSAmPtcNiSitICY-1w2JKDV8IldLoHGJfXdgi1crcb9j-qHYgmuAuLq8YXgW8ElF&strext=1&vs=761e6eaf3499c2ff&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRENzQVJ3eWFhMmx5bXdEQUJRaE1nNjVOS0VEYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dPSHEtaHRpdy1JZ0p3ZGpBS3RMU2R6R3lnOEtickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqzGmeTMjYwEFQIoAkMzLBdAIKp--dsi0RgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDo1-PM2F33ifbY8AMGBl8vIaW5poB4cje44fkp5yZLpw&oe=6794A1DA&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468722756_2558089844376993_1898227210247922960_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeH1HkI8o-UFOLpYdDJT95eC8PZTiFlve-3w9lOIWW977Rnsu3R9gKCBNCaUxHtawxYzanrpaVVHSmYAv2lGuN89&_nc_ohc=6s_VcLJtH4UQ7kNvgEFIDQr&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBM-TMPKLgBF9bxGcP-KNQNqw3ynmchsq82m1nPD1bWPw&oe=679876B3",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "3.61",
      },

      {
        id: "120214748343300682",

        name: "Ad7 - Site ideal",

        effective_status: "ADSET_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468755561_120214658135450682_207435310976084593_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeFYfMHtAgGvt7PVII7Ogb9otCUVcXlgCGC0JRVxeWAIYFmxpIm4GE0gDB2fPHkFsJnQGC-2fRZr_8ky5O4AwOnK&_nc_ohc=P7LnhUcdd88Q7kNvgHsAMc2&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&oh=00_AYCiDEMdVGRfAWDkBOuXm56XCAws_gc84enBJvBf0L4ZWQ&oe=679864B4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "45.7",
      },

      {
        id: "120214748343330682",

        name: "Ad6 - Reels",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYDCkmsmQvhGD7mn_1vtyvKruRQglEP9SljGf5vW_NmlHA&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.2",
      },

      {
        id: "120214748343350682",

        name: "Ad1 - Mapa Google",

        effective_status: "PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=890911&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&oh=00_AYBNbWRecrIokKLsTu1Y_QVnguwzDryOJZrroYd-c2Eedw&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214783380340682",

        name: "Ad8 - Reels Mapa Interativo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQON1JWQGWaBXUUha6vd-QLQB-aVnMW50LMMd28k8V4PCQIbYDBsy4EodJrlNjRd9uqSl9y5OKx3Gj4QIDteSJU9.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEyNzY2MTg0MjY5OTE5NzAsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=102&_nc_eui2=AeEHBbjFoHzCt7lIMwa0VBz1EfoIdx4xOO4R-gh3HjE47qY4Y2Oth5i2x5IImACN-lDEOLlroJlTwbkhyiQiRazI&strext=1&vs=6c8c619c209364a0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRlhYQmh4MDduSUd1VDRHQUlHTHRvOVcxN01jYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMlUtaHZHZi1vLU5yZ0dBSHZRWmJPam1ORnZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsSV1r38xMQEFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC2yQo3tP8mViWYfYnOz7G8brKdxDXlCDYEgv8L7Ta98g&oe=679471E5&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470325071_1972909299858333_5262403533913648451_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeExe1_801uyFnR87DjWvzwJboSTK4Udx-xuhJMrhR3H7K8A0HkxyWKjbjtNdoiqpfEkggRtnns1AzGK0apC13ag&_nc_ohc=Ist8OTy1anIQ7kNvgFDCtTs&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAU6QBiMKeLShfzdQnckJVXee8rXJbVnFlcfFxynFtrLg&oe=67989219",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "364",
      },

      {
        id: "120214890798680682",

        name: "Ad7 - Simulador",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNsOVsatTfdhaPFjF6PZ_ZhWZ41nbAXchj39FEdK2hw-Zd7SSm_ejVSjxnHmOu50ZE44KpX2fPIuILaHe-Lo3fD.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU0MjE2MjY1MTk4OTIzNSwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=104&_nc_eui2=AeHKQfszAPIAyczNQ-v8-zDNnFYdCAgE8IWcVh0ICATwhQkhPyzcqo-RSAt7-KPH-rbCQQ4tEwgMslu33imNVYGv&strext=1&vs=5f105d64d102fcb2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSXJUQVJ3WGtJU3hkbjBHQUNjVFItNEV4NnBEYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dJZVctUnVRZEJrOHVRUURBT3ctSzJ4UDZMbzZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJuaTwsSCxvYBFQIoAkMzLBdAIWZmZmZmZhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYAz8aHZDW0KJUGg_-4-iZ8nGtj7R_vhS2-U9j5o0SaFVA&oe=679493C7&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469836951_2026316341139254_7491305635629217068_n.jpg?_nc_cat=104&ccb=1-7&_nc_eui2=AeGSvrS6oFKEOHR5GNnwHRvdoCDCa3AMDyWgIMJrcAwPJUylzAZgDXfcWtEKk8AOY2p1S8fi4gSRDyVUAMBuA6Fz&_nc_ohc=WRm7jB471PoQ7kNvgG3Wsag&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAoSMeX8IEsgo4KxAx2Ril-Kk7Uw09jF4xAEpDxotCTZQ&oe=679897C4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214890921590682",

        name: "Ad7 - Simulador",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNsOVsatTfdhaPFjF6PZ_ZhWZ41nbAXchj39FEdK2hw-Zd7SSm_ejVSjxnHmOu50ZE44KpX2fPIuILaHe-Lo3fD.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU0MjE2MjY1MTk4OTIzNSwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=104&_nc_eui2=AeHKQfszAPIAyczNQ-v8-zDNnFYdCAgE8IWcVh0ICATwhQkhPyzcqo-RSAt7-KPH-rbCQQ4tEwgMslu33imNVYGv&strext=1&vs=5f105d64d102fcb2&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HSXJUQVJ3WGtJU3hkbjBHQUNjVFItNEV4NnBEYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dJZVctUnVRZEJrOHVRUURBT3ctSzJ4UDZMbzZickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJuaTwsSCxvYBFQIoAkMzLBdAIWZmZmZmZhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYAz8aHZDW0KJUGg_-4-iZ8nGtj7R_vhS2-U9j5o0SaFVA&oe=679493C7&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469836951_2026316341139254_7491305635629217068_n.jpg?_nc_cat=104&ccb=1-7&_nc_eui2=AeGSvrS6oFKEOHR5GNnwHRvdoCDCa3AMDyWgIMJrcAwPJUylzAZgDXfcWtEKk8AOY2p1S8fi4gSRDyVUAMBuA6Fz&_nc_ohc=WRm7jB471PoQ7kNvgG3Wsag&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAoSMeX8IEsgo4KxAx2Ril-Kk7Uw09jF4xAEpDxotCTZQ&oe=679897C4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214886505440682",

        name: "Ad1 - Reels mapa interativo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMNkIfRzfDZ4GWw7UmiiWuvUNG8SIIq5K6GB0VXhLTYEmASd8rkFU6Bg3lU28zK-HILdxAbCF1C_5b5O_1svgTr.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwOTQyMDA4MTkxNTU5MzcsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=111&_nc_eui2=AeGOCKgYLnWi-MtRKlb4cTCP7AuzpR5jl47sC7OlHmOXjtlaxnbr_v9pzxWlk0zaJq_oiRx85ScivY9BHSYGX0_C&strext=1&vs=1aba8d3face40a95&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQldfQWh6ZGlHOGF5aGtOQU1HOFdHNDBEbzljYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMXpCQnhrdFllaV9Mc05BSm54aUVYVmxqQTFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsKPnLLvyvEDFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYBxR0IBPKpHZ8Qn0_PX-TEtI8EuTeZzwj4ROQ-sStrX3Q&oe=67949F4A&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470017033_1091266409105727_1849412484213479495_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeFVbm5G5DVJWxTC_jkgGNPrlpm2OI_cwf-WmbY4j9zB__DUAVrBrYY248Bo9MAKPwOSxiYOEyf4At_b_Eo7BmPy&_nc_ohc=DWtWlM_KCgYQ7kNvgHdaslg&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYD0afn44wDYgvkXsfvs9hRugRJozFmAzMBWJF7XWr2zgA&oe=679869B5",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.04",
      },

      {
        id: "120214885875930682",

        name: "Ad1 - Reels Mapa Interativo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMNkIfRzfDZ4GWw7UmiiWuvUNG8SIIq5K6GB0VXhLTYEmASd8rkFU6Bg3lU28zK-HILdxAbCF1C_5b5O_1svgTr.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwOTQyMDA4MTkxNTU5MzcsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=111&_nc_eui2=AeGOCKgYLnWi-MtRKlb4cTCP7AuzpR5jl47sC7OlHmOXjtlaxnbr_v9pzxWlk0zaJq_oiRx85ScivY9BHSYGX0_C&strext=1&vs=1aba8d3face40a95&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQldfQWh6ZGlHOGF5aGtOQU1HOFdHNDBEbzljYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dKMXpCQnhrdFllaV9Mc05BSm54aUVYVmxqQTFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJsKPnLLvyvEDFQIoAkMzLBdAO4hysCDEnBgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYBxR0IBPKpHZ8Qn0_PX-TEtI8EuTeZzwj4ROQ-sStrX3Q&oe=67949F4A&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/470017033_1091266409105727_1849412484213479495_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeFVbm5G5DVJWxTC_jkgGNPrlpm2OI_cwf-WmbY4j9zB__DUAVrBrYY248Bo9MAKPwOSxiYOEyf4At_b_Eo7BmPy&_nc_ohc=DWtWlM_KCgYQ7kNvgHdaslg&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYD0afn44wDYgvkXsfvs9hRugRJozFmAzMBWJF7XWr2zgA&oe=679869B5",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.05",
      },

      {
        id: "120214889499550682",

        name: "Ad4 - CRM Gustavo",

        effective_status: "ADSET_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQN3CvUafTorU7Ma7iwLYYgMrxrDRpLjPRDe_aTAjyRpMIUamnXIYM51JC3DhRO1PoYfDfaf8C8JGTTTu0HifNC1.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjM4MzE3OTE2NTM3MzgyNzEsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=100&_nc_eui2=AeG6zTQXA_BMigvz7zyDE7LkgDMdUHaH1K2AMx1QdofUrVqsqfFaY_DTHpuWnlYrlsgRA7ICDwGzOUtncB_Oa1R9&strext=1&vs=4a2996ff35d5879a&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HRHpfQVJ3MWNtLWhFb0FEQUVwdG5xM1p4dU1QYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBdlctUnVKQnBkUlZmRURBRXZZMlI3UXpPQkdickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJr7c_sXQv84NFQIoAkMzLBdAHAAAAAAAABgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYCzPQAtyuhBcNPP8B2uG4UIltRstPKMsMv6EnG008CdoQ&oe=67947807&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/469564027_572161368849962_4156503067035956185_n.jpg?_nc_cat=108&ccb=1-7&_nc_eui2=AeHldUGLAKVwFDcc_ezFbCw2T5QySEO5nKJPlDJIQ7mcolXpi4GUMyxDdwnmtUERSiss4Bj4cytAOHjGkGR8zZ-1&_nc_ohc=IpBYxDvJLv0Q7kNvgHAfMQe&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=Ao83l4El6vRuVd9G4xkwIr-&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYANDawmgh5521TOHS1IQSo31EDJ-ubCUA_gluLj411b6w&oe=6798951A",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120214368101250682",

    name: "[FP] [Cadastro Instantâneo] [Público Morno]",

    objective: "OUTCOME_LEADS",

    status: "PAUSED",

    effective_status: "PAUSED",

    insights: {
      spend: "656.93",

      impressions: "35971",

      clicks: "815",

      actions: [
        {
          action_type: "onsite_web_app_view_content",

          value: "53",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "2",
        },

        {
          action_type: "landing_page_view",

          value: "31",
        },

        {
          action_type: "onsite_web_view_content",

          value: "53",
        },

        {
          action_type: "complete_registration",

          value: "7",
        },

        {
          action_type: "post_engagement",

          value: "535",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "16",
        },

        {
          action_type: "comment",

          value: "2",
        },

        {
          action_type: "page_engagement",

          value: "537",
        },

        {
          action_type: "lead",

          value: "55",
        },

        {
          action_type: "view_content",

          value: "53",
        },

        {
          action_type: "onsite_web_lead",

          value: "7",
        },

        {
          action_type: "post",

          value: "6",
        },

        {
          action_type: "omni_complete_registration",

          value: "7",
        },

        {
          action_type: "like",

          value: "2",
        },

        {
          action_type: "offsite_conversion.fb_pixel_lead",

          value: "7",
        },

        {
          action_type: "search",

          value: "1",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "3",
        },

        {
          action_type: "onsite_conversion.lead_grouped",

          value: "48",
        },

        {
          action_type: "offsite_conversion.fb_pixel_search",

          value: "1",
        },

        {
          action_type: "video_view",

          value: "123",
        },

        {
          action_type: "omni_view_content",

          value: "53",
        },

        {
          action_type: "offsite_conversion.fb_pixel_view_content",

          value: "53",
        },

        {
          action_type: "post_reaction",

          value: "84",
        },

        {
          action_type: "offsite_conversion.fb_pixel_complete_registration",

          value: "7",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "2",
        },

        {
          action_type: "link_click",

          value: "304",
        },

        {
          action_type: "omni_search",

          value: "1",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "omni_search",

          value: "656.93",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "328.465",
        },

        {
          action_type: "omni_view_content",

          value: "12.394906",
        },

        {
          action_type: "video_view",

          value: "5.340894",
        },

        {
          action_type: "link_click",

          value: "2.160954",
        },

        {
          action_type: "like",

          value: "328.465",
        },

        {
          action_type: "complete_registration",

          value: "93.847143",
        },

        {
          action_type: "omni_complete_registration",

          value: "93.847143",
        },

        {
          action_type: "onsite_web_lead",

          value: "93.847143",
        },

        {
          action_type: "lead",

          value: "11.944182",
        },

        {
          action_type: "page_engagement",

          value: "1.223333",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "41.058125",
        },

        {
          action_type: "search",

          value: "656.93",
        },

        {
          action_type: "view_content",

          value: "12.394906",
        },

        {
          action_type: "post_engagement",

          value: "1.227907",
        },

        {
          action_type: "landing_page_view",

          value: "21.19129",
        },

        {
          action_type: "onsite_conversion.lead_grouped",

          value: "13.686042",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "328.465",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "12.394906",
        },

        {
          action_type: "onsite_web_view_content",

          value: "12.394906",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "218.976667",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120214658100340682",

        name: "AD / Estático",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&oh=00_AYCHyB4MEaJrTKw_FdoU11wgvahKbxbg3LRGunwjavKYLg&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214657763670682",

        name: "AD / Reels mundo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYC59177mPTGGN84MWKLe-GikM4XkmvW24VdjP2ak71Ypg&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101190682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBWXaklVoLjr91aCBn_9jsFCM_NpR1YuVwomiYnwyBthA&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101180682",

        name: "AD | Mapa de Vendas",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYDCBIy-uVIKa0UV7g_ihPwCyT7Ag6YRmgbWo-8uPBnCHQ&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214399370140682",

        name: "AD / Reels Black November",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNBtLPBTyRjZz8arlZkw46b6NLVr9u07IQ8J-tNZleGMIEMiiWOfBZBhRlw6JNRTD2Mn8N8Md3QEN8XNTWnQpK6.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjk4OTMxMzg0NjU0NjQ1MiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeGpQabkNtmuSRFhmEgnJyoTgU0KkJAJ-_eBTQqQkAn79wBz5996rZQvFtdS5i1Lm_N3ffQEey305D6Gt7X7TU1V&strext=1&vs=a9f4a5bfb1ec4d6e&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HUGVmNGh2WVJMNS0tQTRDQU1zTFZXQVR0TGR4Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBVnc0QnRIUDY0bGFJME5BTzR0YzlyRkM1Z05ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqjAqMbS8cEDFQIoAkMzLBdAPndLxqfvnhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC3cvNt4BUhdfLehHsp7KKPmldiiTw1OOpsaHPacccbHA&oe=679479D1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467517693_3789482444601471_842377333092311274_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeHqzW4ACawCUo0V6eK1wC_Z7er-YPTJhkvt6v5g9MmGS89y0V9iwLl0WRiK7WUE8uyK-J_PUbGx7pZm4nLno8Lc&_nc_ohc=--LwDvFP-dYQ7kNvgFaThSJ&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYDRh5ZoUf4hJosDqXPtJ0Y4yCelxzhDCGwtbmcVEoeLBQ&oe=67987DF0",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101340682",

        name: "AD | Black Friday",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101280682",

        name: "AD | Mapa Google",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAvJX0jkszov9IgKJKiqBCDMGhgc5tlPLm8kcVFOX5Tpg&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214456341660682",

        name: "AD / Reels Black November",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOwqD6tgMK_0wKIWfFpoh1-nbPFq66zNp1z5E0wnlkZwN_Th_790mPKreWtVxXKNNizKybWlIyRoWq_MstLa-qt.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjU1NTQwNzI1Mzc5NzkxNiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=103&_nc_eui2=AeEKEvDFD_fyb3gOogDt5ARberB_w0JkKTt6sH_DQmQpO1HCmmozMRj5mDK9ON0aIR_IyfWjiPMgYnkgUJQ2y628&strext=1&vs=94f1ed0cd2fe993c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HS0pENnh0OGNDR0RHOFlCQU9fNnNsWWlDc1lBYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dLcEU2QnNHWUZJWUhoSUdBT1d4dm9KZW1zNV9ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJrjwi8H6yPwBFQIoAkMzLBdAQUzMzMzMzRgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDchU-PzWRXmAwwoLnGOoI2Ebt-e41jCLIRkhiUlFMP9g&oe=67948BA2&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467428736_558851930200445_8473056545262988083_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeGxZTGV1hgtQxZHS-LRBJ2JKnqhb3PR-cYqeqFvc9H5xm9vfpx-9SklywXp5dBkeT5o-HutI76bzkpPiC7H5E7a&_nc_ohc=s7WhL8_YYWcQ7kNvgEp8ah7&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBW01c4GsBiuuZFiQRq22q9roB3omWAJXC6zVFpS5STvw&oe=67987A80",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214658100360682",

        name: "AD / Estático",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&oh=00_AYCHyB4MEaJrTKw_FdoU11wgvahKbxbg3LRGunwjavKYLg&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214658100350682",

        name: "AD / Estático",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&oh=00_AYCHyB4MEaJrTKw_FdoU11wgvahKbxbg3LRGunwjavKYLg&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214658018830682",

        name: "AD / Estático",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          image_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/468905696_120214658081410682_6214630759726566816_n.png?stp=dst-jpg_tt6&_nc_cat=102&ccb=1-7&_nc_sid=890911&_nc_eui2=AeF8Guofr_v2frDDyTrYWvs6KDD05TyXxlEoMPTlPJfGUbe6UKpJTOSzyxvzdCJOlFmGxfFvkSu6TwNbJ_p76UiS&_nc_ohc=vEUOq9i10Y8Q7kNvgGxnHWQ&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&oh=00_AYCHyB4MEaJrTKw_FdoU11wgvahKbxbg3LRGunwjavKYLg&oe=679867D9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214657763640682",

        name: "AD / Reels mundo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYC59177mPTGGN84MWKLe-GikM4XkmvW24VdjP2ak71Ypg&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214657763650682",

        name: "AD / Reels mundo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYC59177mPTGGN84MWKLe-GikM4XkmvW24VdjP2ak71Ypg&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101150682",

        name: "AD | Black Friday",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101320682",

        name: "AD | Mapa Google",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAvJX0jkszov9IgKJKiqBCDMGhgc5tlPLm8kcVFOX5Tpg&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101240682",

        name: "AD | Mapa Google",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAvJX0jkszov9IgKJKiqBCDMGhgc5tlPLm8kcVFOX5Tpg&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101210682",

        name: "AD | Mapa de Vendas",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYDCBIy-uVIKa0UV7g_ihPwCyT7Ag6YRmgbWo-8uPBnCHQ&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101230682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBWXaklVoLjr91aCBn_9jsFCM_NpR1YuVwomiYnwyBthA&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214657637060682",

        name: "AD / Reels mundo",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMlzhGBhO6XtIZ2yej5qZJjTQCnHzVSIVMx_GjC6f1lq6dX4Za_CYr0VW_bKSI5kn2RFYUIE3FcZGTIp8bC23-e.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjEwNjY2MzM0MDE5MjM1NjQsInZlbmNvZGVfdGFnIjoieHB2X3Byb2dyZXNzaXZlLkZBQ0VCT09LLi5DMy43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeF_w63g-SShBCDOcJrmuSXGvOwtsDAgQHm87C2wMCBAeR2XQk5u-c90uA6NxNUxgo-gez16MWGY8ROhLa-447LB&strext=1&vs=b1e933956e33bdb6&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTnVBOVJzRlc5SFJiaFVIQU5UbzFvallOcmgwYm1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dEZ1g5UnNGZC1WYlNNY0ZBTXludmVYMXZXTXFickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtjft5CehuUDFQIoAkMzLBdAJCHKwIMSbxgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYDGD5_8eoszBT83_2YDlQ6LiX3G0znR_qIu3npqbNqXeA&oe=679498E1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/468661101_503710066028463_6642921261849525372_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHCKMEmchpuBQgxCNR4zvb9SV5iZphPOolJXmJmmE86iWP1d8GhZNv__0Bd18iFJiDNWmsU6VUiL8KXIBzjF7pw&_nc_ohc=5jLRzd-Ou-EQ7kNvgGUBVcq&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYC59177mPTGGN84MWKLe-GikM4XkmvW24VdjP2ak71Ypg&oe=67986330",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101170682",

        name: "AD | Black Friday",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101270682",

        name: "AD | Mapa de Vendas",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYDCBIy-uVIKa0UV7g_ihPwCyT7Ag6YRmgbWo-8uPBnCHQ&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214368101330682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBWXaklVoLjr91aCBn_9jsFCM_NpR1YuVwomiYnwyBthA&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214393232970682",

        name: "AD | Black Friday",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214393233010682",

        name: "AD | Mapa Google",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAvJX0jkszov9IgKJKiqBCDMGhgc5tlPLm8kcVFOX5Tpg&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214393232990682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AgF0sg0xOJAIt7Tw_lHUNfu&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBWXaklVoLjr91aCBn_9jsFCM_NpR1YuVwomiYnwyBthA&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120214187169220682",

    name: "[F] [ENGAJAMENTO WHATSAPP] - TESTE",

    objective: "OUTCOME_ENGAGEMENT",

    status: "PAUSED",

    effective_status: "PAUSED",

    insights: {
      spend: "76.33",

      impressions: "3017",

      clicks: "28",

      actions: [
        {
          action_type: "onsite_conversion.total_messaging_connection",

          value: "7",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "5",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "5",
        },

        {
          action_type: "onsite_web_view_content",

          value: "5",
        },

        {
          action_type: "post_engagement",

          value: "56",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "1",
        },

        {
          action_type: "page_engagement",

          value: "57",
        },

        {
          action_type: "view_content",

          value: "5",
        },

        {
          action_type: "onsite_conversion.messaging_user_depth_3_message_send",

          value: "3",
        },

        {
          action_type: "onsite_conversion.messaging_user_depth_2_message_send",

          value: "5",
        },

        {
          action_type: "like",

          value: "1",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "9",
        },

        {
          action_type: "video_view",

          value: "40",
        },

        {
          action_type: "omni_view_content",

          value: "5",
        },

        {
          action_type: "offsite_conversion.fb_pixel_view_content",

          value: "5",
        },

        {
          action_type: "post_reaction",

          value: "2",
        },

        {
          action_type: "link_click",

          value: "13",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "onsite_conversion.total_messaging_connection",

          value: "10.904286",
        },

        {
          action_type: "omni_view_content",

          value: "15.266",
        },

        {
          action_type: "video_view",

          value: "1.90825",
        },

        {
          action_type: "link_click",

          value: "5.871538",
        },

        {
          action_type: "like",

          value: "76.33",
        },

        {
          action_type: "onsite_conversion.messaging_user_depth_2_message_send",

          value: "15.266",
        },

        {
          action_type: "page_engagement",

          value: "1.339123",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "76.33",
        },

        {
          action_type: "onsite_conversion.messaging_user_depth_3_message_send",

          value: "25.443333",
        },

        {
          action_type: "view_content",

          value: "15.266",
        },

        {
          action_type: "post_engagement",

          value: "1.363036",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "15.266",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "15.266",
        },

        {
          action_type: "onsite_web_view_content",

          value: "15.266",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "8.481111",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120214187169300682",

        name: "AD | Mapa de Vendas",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AGXe6FdTg-Dv1pbnnmei0Pd&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYCfMov1s39q_dAjZHyccOwyGzvJ89xGxpC3kjqTBAIrtQ&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214202551290682",

        name: "AD | Black Friday",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2467867052726755203?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQLZn07arBfTUFlhCPwQLQWtS5-6pUsnNmElCbiH535QeS0QOy79_kfsM-4jG9SiYjnk9gLIttMTH2yxZihj-rs0Jtb0VrqmtUdm57mmiEQaXycUTBP2HVFDCBDRH3PhWXXkcH7YCtP_a1fwc27iNP3I&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeFylgvSQVgxYI8dL_fnIuFf3pbO-0apv5fels77Rqm_l9cThtT3HF1M1WZp1FJ2PGCokzDsDmpL868BLkvH4owv&ccb=13-1&oh=06_Q39968LPwY4ZKvewYrEpdOCzvtBzKtir3wQ7r4N8My8nOOQ&oe=67949099&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120209562769610682",

    name: "📄 [SENSEYS] [Público Frio]",

    objective: "OUTCOME_LEADS",

    status: "PAUSED",

    effective_status: "PAUSED",

    insights: {
      spend: "13733.41",

      impressions: "838580",

      clicks: "14057",

      actions: [
        {
          action_type: "onsite_web_app_view_content",

          value: "239",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "7",
        },

        {
          action_type: "landing_page_view",

          value: "725",
        },

        {
          action_type: "onsite_web_view_content",

          value: "239",
        },

        {
          action_type: "complete_registration",

          value: "6",
        },

        {
          action_type: "post_engagement",

          value: "12569",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "304",
        },

        {
          action_type: "comment",

          value: "34",
        },

        {
          action_type: "page_engagement",

          value: "12604",
        },

        {
          action_type: "lead",

          value: "1353",
        },

        {
          action_type: "view_content",

          value: "239",
        },

        {
          action_type: "onsite_web_lead",

          value: "149",
        },

        {
          action_type: "post",

          value: "344",
        },

        {
          action_type: "omni_complete_registration",

          value: "6",
        },

        {
          action_type: "like",

          value: "35",
        },

        {
          action_type: "offsite_conversion.fb_pixel_lead",

          value: "149",
        },

        {
          action_type: "search",

          value: "48",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "15",
        },

        {
          action_type: "onsite_conversion.lead_grouped",

          value: "1204",
        },

        {
          action_type: "offsite_conversion.fb_pixel_search",

          value: "48",
        },

        {
          action_type: "video_view",

          value: "4212",
        },

        {
          action_type: "omni_view_content",

          value: "239",
        },

        {
          action_type: "offsite_conversion.fb_pixel_view_content",

          value: "239",
        },

        {
          action_type: "post_reaction",

          value: "1779",
        },

        {
          action_type: "offsite_conversion.fb_pixel_complete_registration",

          value: "6",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "40",
        },

        {
          action_type: "link_click",

          value: "5896",
        },

        {
          action_type: "omni_search",

          value: "48",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "omni_search",

          value: "286.112708",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "343.33525",
        },

        {
          action_type: "omni_view_content",

          value: "57.461967",
        },

        {
          action_type: "video_view",

          value: "3.260544",
        },

        {
          action_type: "link_click",

          value: "2.329276",
        },

        {
          action_type: "like",

          value: "392.383143",
        },

        {
          action_type: "complete_registration",

          value: "2288.901667",
        },

        {
          action_type: "omni_complete_registration",

          value: "2288.901667",
        },

        {
          action_type: "onsite_web_lead",

          value: "92.170537",
        },

        {
          action_type: "lead",

          value: "10.15034",
        },

        {
          action_type: "page_engagement",

          value: "1.089607",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "45.175691",
        },

        {
          action_type: "search",

          value: "286.112708",
        },

        {
          action_type: "view_content",

          value: "57.461967",
        },

        {
          action_type: "post_engagement",

          value: "1.092641",
        },

        {
          action_type: "landing_page_view",

          value: "18.942634",
        },

        {
          action_type: "onsite_conversion.lead_grouped",

          value: "11.406487",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "1961.915714",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "57.461967",
        },

        {
          action_type: "onsite_web_view_content",

          value: "57.461967",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "915.560667",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120209563588340682",

        name: "AD | Mapa Google",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYBON4cOfeMrQDUxoE2ExGH9yPu7HkwhqSCKGR12JI76BQ&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563444920682",

        name: "AD | Mapa Google",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYBON4cOfeMrQDUxoE2ExGH9yPu7HkwhqSCKGR12JI76BQ&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214202039970682",

        name: "AD | Black Friday",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214202039980682",

        name: "AD | Black Friday",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214202039940682",

        name: "AD | Black Friday",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214201786010682",

        name: "AD | Black Friday",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://external.fcpq7-1.fna.fbcdn.net/emg1/v/t13/2593768693125714809?url=https%3A%2F%2Fwww.facebook.com%2Fads%2Fimage%2F%3Fd%3DAQIJKkP7Jwt8rhs0DIsJX14X1qzEVQwAir_dH2wvRYLE_zbL1roT5dtHHiGGngL0ZPe7YZQg5JaRNj7WeW8d4-J2k6xn_trh_qzMsxmo7Av-V8ebQg4VSxMZwyDMx_turrYeGWgrNoO_dpQeYVndUue0&fb_obo=1&utld=facebook.com&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&_nc_eui2=AeEgaCeqt8eLWbU4_4yPIBiLA_GZBC0IB-ED8ZkELQgH4SfMf4CzUl-ayzvVCyNS2lmkSEs0kajW5LCUqG922iLE&ccb=13-1&oh=06_Q399_lqIEi21JvRSGfnf1rhdzoWmH6lZ-wCiA4aHRD8Hm5M&oe=679491A1&_nc_sid=58080a",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563613320682",

        name: "AD | Mapa Google",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYBON4cOfeMrQDUxoE2ExGH9yPu7HkwhqSCKGR12JI76BQ&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563613310682",

        name: "AD | Mapa de Vendas",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYC-9f9eYC23lSmgXHHvtw9t3SOuWKt1RyyZoDtn1Ov77g&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563613330682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBGhiuBDLsACpF_NmAAkbmWHJBz12JyLaZQdGJLj_PKpA&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563588350682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBGhiuBDLsACpF_NmAAkbmWHJBz12JyLaZQdGJLj_PKpA&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563588370682",

        name: "AD | Mapa de Vendas",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYC-9f9eYC23lSmgXHHvtw9t3SOuWKt1RyyZoDtn1Ov77g&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563492900682",

        name: "AD | Mapa Google",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYBON4cOfeMrQDUxoE2ExGH9yPu7HkwhqSCKGR12JI76BQ&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563492890682",

        name: "AD | Mapa de Vendas",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYC-9f9eYC23lSmgXHHvtw9t3SOuWKt1RyyZoDtn1Ov77g&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563492870682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBGhiuBDLsACpF_NmAAkbmWHJBz12JyLaZQdGJLj_PKpA&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209563452750682",

        name: "AD | Mapa de Vendas",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYC-9f9eYC23lSmgXHHvtw9t3SOuWKt1RyyZoDtn1Ov77g&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209562769700682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AI3XFaXqfPmWH1KTdDaldzN&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBGhiuBDLsACpF_NmAAkbmWHJBz12JyLaZQdGJLj_PKpA&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120209479884680682",

    name: "🤝 [SENSEYS] [Branding] [Site] [Alcance]",

    objective: "OUTCOME_ENGAGEMENT",

    status: "PAUSED",

    effective_status: "PAUSED",

    insights: {
      spend: "3237.09",

      impressions: "464862",

      clicks: "502",

      actions: [
        {
          action_type: "landing_page_view",

          value: "161",
        },

        {
          action_type: "post_engagement",

          value: "362008",
        },

        {
          action_type: "page_engagement",

          value: "362008",
        },

        {
          action_type: "video_view",

          value: "361511",
        },

        {
          action_type: "post_reaction",

          value: "3",
        },

        {
          action_type: "link_click",

          value: "494",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "video_view",

          value: "0.008954",
        },

        {
          action_type: "link_click",

          value: "6.552814",
        },

        {
          action_type: "page_engagement",

          value: "0.008942",
        },

        {
          action_type: "post_engagement",

          value: "0.008942",
        },

        {
          action_type: "landing_page_view",

          value: "20.106149",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120214400150790682",

        name: "AD / Reels Black November",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNBtLPBTyRjZz8arlZkw46b6NLVr9u07IQ8J-tNZleGMIEMiiWOfBZBhRlw6JNRTD2Mn8N8Md3QEN8XNTWnQpK6.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjk4OTMxMzg0NjU0NjQ1MiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLmhodm10cnVuay43MjAuZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcCJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeGpQabkNtmuSRFhmEgnJyoTgU0KkJAJ-_eBTQqQkAn79wBz5996rZQvFtdS5i1Lm_N3ffQEey305D6Gt7X7TU1V&strext=1&vs=a9f4a5bfb1ec4d6e&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HUGVmNGh2WVJMNS0tQTRDQU1zTFZXQVR0TGR4Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBVnc0QnRIUDY0bGFJME5BTzR0YzlyRkM1Z05ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqjAqMbS8cEDFQIoCWhodm10cnVuaywXQD53S8an754YGWRhc2hfaDI2NC1iYXNpYy1nZW4yXzcyMHARAHUCAA&ccb=9-4&oh=00_AYC8i0qJKLI1Inj3967q5Dfa2g09S3tlyjJFusVIJh70Pw&oe=679479D1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467517693_3789482444601471_842377333092311274_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeHqzW4ACawCUo0V6eK1wC_Z7er-YPTJhkvt6v5g9MmGS89y0V9iwLl0WRiK7WUE8uyK-J_PUbGx7pZm4nLno8Lc&_nc_ohc=--LwDvFP-dYQ7kNvgFaThSJ&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAm0jWm-oHr7fIE1zTguuBx2_3NzroodjstQHb9CpbBRA&oe=67987DF0",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120214399955340682",

        name: "AD / Reels Black November",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQNBtLPBTyRjZz8arlZkw46b6NLVr9u07IQ8J-tNZleGMIEMiiWOfBZBhRlw6JNRTD2Mn8N8Md3QEN8XNTWnQpK6.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjk4OTMxMzg0NjU0NjQ1MiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2gyNjQtYmFzaWMtZ2VuMl83MjBwIn0&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=110&_nc_eui2=AeGpQabkNtmuSRFhmEgnJyoTgU0KkJAJ-_eBTQqQkAn79wBz5996rZQvFtdS5i1Lm_N3ffQEey305D6Gt7X7TU1V&strext=1&vs=a9f4a5bfb1ec4d6e&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HUGVmNGh2WVJMNS0tQTRDQU1zTFZXQVR0TGR4Ym1kakFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dBVnc0QnRIUDY0bGFJME5BTzR0YzlyRkM1Z05ickZxQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJqjAqMbS8cEDFQIoAkMzLBdAPndLxqfvnhgZZGFzaF9oMjY0LWJhc2ljLWdlbjJfNzIwcBEAdQIA&ccb=9-4&oh=00_AYC3cvNt4BUhdfLehHsp7KKPmldiiTw1OOpsaHPacccbHA&oe=679479D1&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/467517693_3789482444601471_842377333092311274_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeHqzW4ACawCUo0V6eK1wC_Z7er-YPTJhkvt6v5g9MmGS89y0V9iwLl0WRiK7WUE8uyK-J_PUbGx7pZm4nLno8Lc&_nc_ohc=--LwDvFP-dYQ7kNvgFaThSJ&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYAm0jWm-oHr7fIE1zTguuBx2_3NzroodjstQHb9CpbBRA&oe=67987DF0",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209481754550682",

        name: "AD | Video Mapa v1",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMfwAuSuDHkly3a-5MRmkXNhLtYSjqZyMsz5NruL_AJJlkKgj1DADgVazp5NMULdliDFITO1QBkWXw8tn0ssIFA.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQ0OTAzMjg3NzY2Mjg3NiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2hpZ2hfMV92MSJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=105&_nc_eui2=AeGe6X-yICyTtulXWN1GPU4_jE__cVMjvdqMT_9xUyO92kKJ6t3k0QAxMLS-k6zwHPkcrGsVpolunNtuLvHCYMt4&strext=1&vs=630dfc5fc9b77d0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTzZvVHhsOWJxWnZQS1lIQU9JZGZiQ1BVNVVUYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dNbW5SQm8zVXFjSF9MUUZBQUV5OWZuNDdHcy1idjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJriK09KTmcwBFQIoAkMzLBdAOYhysCDEnBgOZGFzaF9oaWdoXzFfdjERAHUCAA&ccb=9-4&oh=00_AYDqWx4QYv840dbycl9lsV9NTBz-0IFyh-OVXernkUD58g&oe=67948908&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/438220570_411298821760268_4056244743871648038_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeED1UmFdu12UL9jOuSAjKRje-5dm2DXTKx77l2bYNdMrIsMORS1bC7RVK3Z5SPE7txviaAb9RlzUQ5vUy2uTFFS&_nc_ohc=U4ttg2ff2tYQ7kNvgH58TXN&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBC8SaMernSCQJlI7jnv8iUcR6X2rBz_X6H912Xd_vGhw&oe=67988FA5",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209481754540682",

        name: "AD | Video IA",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOoo-4-UMOmympo9y1QvqI5vRPDKt8A_dL1UvudEy-Lm3F5fX63_eMISZ9uBLWLYgCc3v_oAAyDN7U4ItKQ6WEM.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQzNTM3MDM3NTczOTM3NCwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2hpZ2hfMV92MSJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=108&_nc_eui2=AeFvsQuQa9OXzDnlQx34Qjohz0jOtCg1rNXPSM60KDWs1esbLnm02yfKzwEQ0TR-mgCubKgNxBOCH-xCnfQ4niK8&strext=1&vs=1dc4e403dfc8844c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQXZlUXhvVjRFYXlsWGNCQUNTMDgwRUNXR3hhYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dQWkRSeHAzUTR5S0lrSUdBTktqSzl3MldRUlNidjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtzfu4ny_cUBFQIoAkMzLBdAL5mZmZmZmhgOZGFzaF9oaWdoXzFfdjERAHUCAA&ccb=9-4&oh=00_AYCKylzOLV2FaJHqBvzrFQ89wl0TWE6HvWjzGwLjA2dtxw&oe=67948BE7&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/426962232_26358581030399395_923893081814852703_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeFcckKgDNisIkzK320-xVa0qetLf9ssUS-p60t_2yxRL62oqr3E1nv-x_YzF73k-xZw9czUVlZui6mFFaSAtV_i&_nc_ohc=Pdl3RR9zBH8Q7kNvgHrdOfF&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCt0wZeKCh-SGcNcIXG6nIQZId07D9yOiyATVSVOKorsw&oe=67988457",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209481754530682",

        name: "AD | Video Mapa v2",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQO9PpIQLwdcYc5xGSSisPNu89l3k5ZiT6fbFP7YfPwZ3XjxrXR3ZFUKd1dDKfG6Wcg7ta2OuTYiWl50VKd4CYbZ.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQyODcwNTgzMDA1MzQyMCwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2hpZ2hfMV92MSJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=108&_nc_eui2=AeFWe3k1EVTAKlLuWlVGtYV6Y3oshWsxGJFjeiyFazEYkRgFhqCYSHHdlxzGhz6vc6uh-wxagK8t4QhQidu2tyQG&strext=1&vs=87b94a07b567edd3&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQVRiU2hwcTJHamtoNGdDQUtkelQzLVB3UTBPYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dIM2RSaHJwOHByR1k0QUZBSGk5NnQ3amgySVhidjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtiYtav7-cIBFQIoAkMzLBdAOSIMSbpeNRgOZGFzaF9oaWdoXzFfdjERAHUCAA&ccb=9-4&oh=00_AYD7HF65656-4gdM3DE5dDW5nmvfJZicRVCjhc2SOTqzMw&oe=6794945B&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/438212874_966271238525289_3980684890386525851_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeEj4O_SBVJvlpEr-tCDhOdxi4R6m7eP-qmLhHqbt4_6qbsLybD4Vi36AHybm97NackOkZkj_Bviajtuf9SXBEVL&_nc_ohc=a_XSJWSix2wQ7kNvgECZyoX&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYDFczALtwFIM2zuBIz7M8JdO15AaZ8uSkV8YsjJDGXW4Q&oe=67987A7F",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209481754520682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYAwD9ekV1KwMrJu-7qX0gqKI9Xseng0oXXNetCHA2bUMg&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209481747330682",

        name: "AD | Video IA",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQOoo-4-UMOmympo9y1QvqI5vRPDKt8A_dL1UvudEy-Lm3F5fX63_eMISZ9uBLWLYgCc3v_oAAyDN7U4ItKQ6WEM.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQzNTM3MDM3NTczOTM3NCwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2hpZ2hfMV92MSJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=108&_nc_eui2=AeFvsQuQa9OXzDnlQx34Qjohz0jOtCg1rNXPSM60KDWs1esbLnm02yfKzwEQ0TR-mgCubKgNxBOCH-xCnfQ4niK8&strext=1&vs=1dc4e403dfc8844c&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQXZlUXhvVjRFYXlsWGNCQUNTMDgwRUNXR3hhYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dQWkRSeHAzUTR5S0lrSUdBTktqSzl3MldRUlNidjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtzfu4ny_cUBFQIoAkMzLBdAL5mZmZmZmhgOZGFzaF9oaWdoXzFfdjERAHUCAA&ccb=9-4&oh=00_AYCKylzOLV2FaJHqBvzrFQ89wl0TWE6HvWjzGwLjA2dtxw&oe=67948BE7&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/426962232_26358581030399395_923893081814852703_n.jpg?_nc_cat=101&ccb=1-7&_nc_eui2=AeFcckKgDNisIkzK320-xVa0qetLf9ssUS-p60t_2yxRL62oqr3E1nv-x_YzF73k-xZw9czUVlZui6mFFaSAtV_i&_nc_ohc=Pdl3RR9zBH8Q7kNvgHrdOfF&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYCt0wZeKCh-SGcNcIXG6nIQZId07D9yOiyATVSVOKorsw&oe=67988457",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209481715810682",

        name: "AD | Video Mapa v2",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQO9PpIQLwdcYc5xGSSisPNu89l3k5ZiT6fbFP7YfPwZ3XjxrXR3ZFUKd1dDKfG6Wcg7ta2OuTYiWl50VKd4CYbZ.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQyODcwNTgzMDA1MzQyMCwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLmhodm10cnVuay43MjAuZGFzaF9oaWdoXzFfdjEifQ&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=108&_nc_eui2=AeFWe3k1EVTAKlLuWlVGtYV6Y3oshWsxGJFjeiyFazEYkRgFhqCYSHHdlxzGhz6vc6uh-wxagK8t4QhQidu2tyQG&strext=1&vs=87b94a07b567edd3&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HQVRiU2hwcTJHamtoNGdDQUtkelQzLVB3UTBPYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dIM2RSaHJwOHByR1k0QUZBSGk5NnQ3amgySVhidjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJtiYtav7-cIBFQIoCWhodm10cnVuaywXQDkiDEm6XjUYDmRhc2hfaGlnaF8xX3YxEQB1AgA&ccb=9-4&oh=00_AYDenfGOn4lQWlG6KHTua7WssBq9lJ7oaLeP22AgNkE-XQ&oe=6794945B&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/438212874_966271238525289_3980684890386525851_n.jpg?_nc_cat=107&ccb=1-7&_nc_eui2=AeEj4O_SBVJvlpEr-tCDhOdxi4R6m7eP-qmLhHqbt4_6qbsLybD4Vi36AHybm97NackOkZkj_Bviajtuf9SXBEVL&_nc_ohc=a_XSJWSix2wQ7kNvgECZyoX&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYDFczALtwFIM2zuBIz7M8JdO15AaZ8uSkV8YsjJDGXW4Q&oe=67987A7F",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209480565650682",

        name: "AD | Video Mapa v1",

        effective_status: "PAUSED",

        media: {
          video_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/o1/v/t2/f2/m69/AQMfwAuSuDHkly3a-5MRmkXNhLtYSjqZyMsz5NruL_AJJlkKgj1DADgVazp5NMULdliDFITO1QBkWXw8tn0ssIFA.mp4?efg=eyJ4cHZfYXNzZXRfaWQiOjQ0OTAzMjg3NzY2Mjg3NiwidmVuY29kZV90YWciOiJ4cHZfcHJvZ3Jlc3NpdmUuRkFDRUJPT0suLkMzLjcyMC5kYXNoX2hpZ2hfMV92MSJ9&_nc_ht=scontent.fcpq7-1.fna.fbcdn.net&_nc_cat=105&_nc_eui2=AeGe6X-yICyTtulXWN1GPU4_jE__cVMjvdqMT_9xUyO92kKJ6t3k0QAxMLS-k6zwHPkcrGsVpolunNtuLvHCYMt4&strext=1&vs=630dfc5fc9b77d0&_nc_vs=HBksFQIYOnBhc3N0aHJvdWdoX2V2ZXJzdG9yZS9HTzZvVHhsOWJxWnZQS1lIQU9JZGZiQ1BVNVVUYmtZTEFBQUYVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dNbW5SQm8zVXFjSF9MUUZBQUV5OWZuNDdHcy1idjRHQUFBRhUCAsgBACgAGAAbAogHdXNlX29pbAExEnByb2dyZXNzaXZlX3JlY2lwZQExFQAAJriK09KTmcwBFQIoAkMzLBdAOYhysCDEnBgOZGFzaF9oaWdoXzFfdjERAHUCAA&ccb=9-4&oh=00_AYDqWx4QYv840dbycl9lsV9NTBz-0IFyh-OVXernkUD58g&oe=67948908&_nc_sid=1d576d",

          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/438220570_411298821760268_4056244743871648038_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeED1UmFdu12UL9jOuSAjKRje-5dm2DXTKx77l2bYNdMrIsMORS1bC7RVK3Z5SPE7txviaAb9RlzUQ5vUy2uTFFS&_nc_ohc=U4ttg2ff2tYQ7kNvgH58TXN&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=ace027&_nc_sid=58080a&oh=00_AYBC8SaMernSCQJlI7jnv8iUcR6X2rBz_X6H912Xd_vGhw&oe=67988FA5",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209479884950682",

        name: "AD | Video Padrao",

        effective_status: "PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYAwD9ekV1KwMrJu-7qX0gqKI9Xseng0oXXNetCHA2bUMg&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120212131371910682",

        name: "AD | Reels Insta IA",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456060756_364899466664886_7048515971288709583_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeHa-RJBMSSZlfh2aZWHsimeoMSGgQXsJvWgxIaBBewm9QmK7AEZ9CsRUIeTdnRBIb37DigTkMwDXS0yF35kvqje&_nc_ohc=JlVO-raO_ygQ7kNvgFGYbDG&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYCH7me-54X3rVRDyB8ynk3tko0rnxYhPUyxCkwiBPRI8A&oe=67987EA4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120212129941310682",

        name: "AD | Reels Insta Case",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456322192_1028081952352462_4741750611119828495_n.jpg?_nc_cat=106&ccb=1-7&_nc_eui2=AeEBSOJsoRpAVIfCPkLrwdps6wMi0eTbw-frAyLR5NvD5-PCwm8WVcQSBpV2yrdmjrzuUpdt1hgPJNDAOghtcoZz&_nc_ohc=a9yQ2rCPABgQ7kNvgGEQKaT&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYClG6ZEspc_YynxAwhDWKo_dsXTLM0cwn7C1jCUkhYLDA&oe=679882AC",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120212129906110682",

        name: "AD | Reels Insta IA",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456061399_2539187706289161_8373357006410509866_n.jpg?_nc_cat=100&ccb=1-7&_nc_eui2=AeH3BIePAxocB4ayxZADB4XyW0P5h7oazRFbQ_mHuhrNETOOw1pNw9ZldNBVBSt8keEOWyp3zYZvGHr6vbVwl1Xr&_nc_ohc=s-JMPWkSo2kQ7kNvgFDJM4r&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYAcDuwphWXghwXuNxDHKkk2Be654qWEpejyqsSSpRIy1A&oe=67987DC4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120212131371920682",

        name: "AD | Reels Insta Atendimento",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456201965_1396846377659450_7384666972614963224_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFPTQBKcfONLmq4Hdxb1CjiocmiHXZUHiGhyaIddlQeIStdSicHkB5jLPb7YkYJ-7zAfnWUwpA_Ld6DS5N334r0&_nc_ohc=g78UA8S5ilgQ7kNvgFcZg75&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYBYCenIA140efhYMztHz-xPqwJIdXNc8ZSsw-ITlkV3cg&oe=67986E4D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120212131371930682",

        name: "AD | Reels Insta Case",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456039110_1818079005688538_938095938554705880_n.jpg?_nc_cat=108&ccb=1-7&_nc_eui2=AeEUiM-SrFy3fs-vkDpmB-QQjXCj6B_VCymNcKPoH9ULKWHAAwfT894UIbf5XhmDXTazHVv-6CzIhIWdoZfjxAHE&_nc_ohc=AUW2juLvvYYQ7kNvgEh0wLi&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYBvTXGGyH2Vt6U9dIJi1iGA7vhvKG8TDE6MCBizFkht7w&oe=679867B4",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120212130579120682",

        name: "AD | Reels Insta Atendimento",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.5256-10/456203116_1959581781181322_8712192002101299045_n.jpg?_nc_cat=106&ccb=1-7&_nc_eui2=AeH3jCYz0UlEfHdCL5DTyriGQOP3TFGwsGBA4_dMUbCwYDMmm8TSnkSK73zXgpYpqv4y8HQcRWSwlBv5x1dv2MjG&_nc_ohc=kaiuDRBISI8Q7kNvgHOllep&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AnOPBR2NddG8PTU4fDI4pV8&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=7965db&_nc_sid=58080a&oh=00_AYCC5bXLeCwglY3AIHfaGMduLvxngGx6-z_-wMPj_EUI5A&oe=67986C2C",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },

  {
    id: "120209474891490682",

    name: "📄 [SENSEYS][Site] [Cadastros]",

    objective: "OUTCOME_ENGAGEMENT",

    status: "PAUSED",

    effective_status: "PAUSED",

    insights: {
      spend: "3442.7",

      impressions: "151142",

      clicks: "2191",

      actions: [
        {
          action_type: "onsite_conversion.total_messaging_connection",

          value: "284",
        },

        {
          action_type: "onsite_conversion.messaging_block",

          value: "1",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "118",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "259",
        },

        {
          action_type: "landing_page_view",

          value: "27",
        },

        {
          action_type: "onsite_web_view_content",

          value: "118",
        },

        {
          action_type: "post_engagement",

          value: "6774",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "120",
        },

        {
          action_type: "comment",

          value: "6",
        },

        {
          action_type: "page_engagement",

          value: "6774",
        },

        {
          action_type: "lead",

          value: "24",
        },

        {
          action_type: "view_content",

          value: "118",
        },

        {
          action_type: "onsite_conversion.messaging_user_depth_3_message_send",

          value: "41",
        },

        {
          action_type: "onsite_web_lead",

          value: "24",
        },

        {
          action_type: "post",

          value: "210",
        },

        {
          action_type: "onsite_conversion.messaging_user_depth_2_message_send",

          value: "88",
        },

        {
          action_type: "offsite_conversion.fb_pixel_lead",

          value: "24",
        },

        {
          action_type: "search",

          value: "11",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "324",
        },

        {
          action_type: "offsite_conversion.fb_pixel_search",

          value: "11",
        },

        {
          action_type: "video_view",

          value: "4998",
        },

        {
          action_type: "omni_view_content",

          value: "118",
        },

        {
          action_type: "offsite_conversion.fb_pixel_view_content",

          value: "118",
        },

        {
          action_type: "post_reaction",

          value: "595",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "14",
        },

        {
          action_type: "link_click",

          value: "845",
        },

        {
          action_type: "omni_search",

          value: "11",
        },
      ],

      cost_per_action_type: [
        {
          action_type: "onsite_conversion.total_messaging_connection",

          value: "12.122183",
        },

        {
          action_type: "onsite_conversion.messaging_block",

          value: "3442.7",
        },

        {
          action_type: "omni_search",

          value: "312.972727",
        },

        {
          action_type: "offsite_conversion.fb_pixel_custom",

          value: "245.907143",
        },

        {
          action_type: "omni_view_content",

          value: "29.175424",
        },

        {
          action_type: "video_view",

          value: "0.688816",
        },

        {
          action_type: "link_click",

          value: "4.074201",
        },

        {
          action_type: "onsite_conversion.messaging_user_depth_2_message_send",

          value: "39.121591",
        },

        {
          action_type: "onsite_web_lead",

          value: "143.445833",
        },

        {
          action_type: "lead",

          value: "143.445833",
        },

        {
          action_type: "page_engagement",

          value: "0.508223",
        },

        {
          action_type: "onsite_conversion.post_save",

          value: "28.689167",
        },

        {
          action_type: "search",

          value: "312.972727",
        },

        {
          action_type: "onsite_conversion.messaging_user_depth_3_message_send",

          value: "83.968293",
        },

        {
          action_type: "view_content",

          value: "29.175424",
        },

        {
          action_type: "post_engagement",

          value: "0.508223",
        },

        {
          action_type: "landing_page_view",

          value: "127.507407",
        },

        {
          action_type: "onsite_conversion.messaging_first_reply",

          value: "13.292278",
        },

        {
          action_type: "onsite_web_app_view_content",

          value: "29.175424",
        },

        {
          action_type: "onsite_web_view_content",

          value: "29.175424",
        },

        {
          action_type: "onsite_conversion.messaging_conversation_started_7d",

          value: "10.625617",
        },
      ],
    },

    adsets: [],

    ads: [
      {
        id: "120209478020830682",

        name: "AD | Mapa de Vendas",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAOa-eLP-DOB9VCpOYNtTryNXEY5qZ-nK1oGcaKeH5QJA&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209478030490682",

        name: "AD | Mapa de Vendas",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAOa-eLP-DOB9VCpOYNtTryNXEY5qZ-nK1oGcaKeH5QJA&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209478030480682",

        name: "AD | Vídeo Padrao",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBokgUUie79icGvVNYojujgFPLYWtjOZpRUM7lfV3s_UQ&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209478030460682",

        name: "AD | Mapa Google",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAYunsGLSWYC6IL4nP7SrN_B43ivy9xDSIoqoyQZNUvjg&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209478020850682",

        name: "AD | Vídeo Padrao",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBokgUUie79icGvVNYojujgFPLYWtjOZpRUM7lfV3s_UQ&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209478020840682",

        name: "AD | Mapa Google",

        effective_status: "CAMPAIGN_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAYunsGLSWYC6IL4nP7SrN_B43ivy9xDSIoqoyQZNUvjg&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209475827330682",

        name: "AD | Vídeo Padrao",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBokgUUie79icGvVNYojujgFPLYWtjOZpRUM7lfV3s_UQ&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209474891540682",

        name: "AD | Mapa Google",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAYunsGLSWYC6IL4nP7SrN_B43ivy9xDSIoqoyQZNUvjg&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209476538210682",

        name: "AD | Mapa de Vendas",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAOa-eLP-DOB9VCpOYNtTryNXEY5qZ-nK1oGcaKeH5QJA&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209476600480682",

        name: "AD | Mapa Google",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/439689000_120209475023690682_4406764388497949194_n.jpg?_nc_cat=110&ccb=1-7&_nc_eui2=AeEv1WEYX_64mSCqhKlbVWiqFSLeoiyhZREVIt6iLKFlEaIx7RsAwIO50-ErKoCO3JftZTJOT8CzoQOqAHc0dRvc&_nc_ohc=GozMEJuFMwEQ7kNvgHA12XT&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAYunsGLSWYC6IL4nP7SrN_B43ivy9xDSIoqoyQZNUvjg&oe=67988CA9",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209476600500682",

        name: "AD | Vídeo Padrao",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t15.13418-10/436639272_3283597798610130_8195276795734325496_n.jpg?_nc_cat=105&ccb=1-7&_nc_eui2=AeFEQ2KlogkWfJRKw5Pw0Pk9Bm34rXVeRDIGbfitdV5EMjx2aXl3laLXcww3Ilfax91gqG5XgkXaTsYIunu0LbVo&_nc_ohc=24pJwrxlWLwQ7kNvgHB1za3&_nc_zt=23&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=1727f7&_nc_sid=58080a&oh=00_AYBokgUUie79icGvVNYojujgFPLYWtjOZpRUM7lfV3s_UQ&oe=6798727D",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },

      {
        id: "120209476600490682",

        name: "AD | Mapa de Vendas",

        effective_status: "ADSET_PAUSED",

        media: {
          thumbnail_url:
            "https://scontent.fcpq7-1.fna.fbcdn.net/v/t45.1600-4/435535341_120209476592580682_2070166978910768727_n.jpg?_nc_cat=111&ccb=1-7&_nc_eui2=AeF0Wl88TjIpen4dP-6nIAD8Xa3BqK3ZiO9drcGordmI77Y0LpPMsT0WbLybaXUFAFhorM4YLNFcsazkzu78pNsI&_nc_ohc=jYhkcmqupcgQ7kNvgFx5Jsm&_nc_zt=1&_nc_ht=scontent.fcpq7-1.fna&edm=ANIILHsEAAAA&_nc_gid=AtkZ5lYYlF251jsAFQyHFY5&stp=c0.5000x0.5000f_dst-emg0_p64x64_q75_tt6&ur=4c02d7&_nc_sid=58080a&oh=00_AYAOa-eLP-DOB9VCpOYNtTryNXEY5qZ-nK1oGcaKeH5QJA&oe=679887F7",
        },

        texts: {
          message: null,

          headline: null,

          description: null,
        },

        cost_per_action_type: [],

        spend: "0.00",
      },
    ],
  },
];

export const ads = canpaigns.flatMap((campaign) =>
  campaign.ads.map((ad) => ({
    ...ad,
    campaignId: campaign.id,
    campaignName: campaign.name,
  }))
);

export const canpaignsOptions = canpaigns
  .filter((c) => c.effective_status === "ACTIVE")
  .map((campaign) => ({
    value: campaign.id,
    label: campaign.name,
  }));
